import { filter } from "lodash";
import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
// material
import {
  Card,
  Stack,
  Container,
  Typography,
  Button,
  Tooltip,
  IconButton,
  Grid,
  TextField,
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormGroup,
  Switch,
  FormControl,
  FormLabel,
  Tabs,
  Tab,
  TableContainer,
  Paper,
  TableBody,
  Table,
  TableRow,
  TableCell,
  TableHead,
  MenuItem,
  CircularProgress,
  Avatar
} from "@mui/material";
import Label from "../components/Label";
import {
  DeleteSharp,
  CalendarMonth,
  EditSharp,
  LogoutSharp,
  CurrencyRupeeSharp,
  RemoveRedEye,
  EmojiEvents,
  VerifiedUser,
  ListAlt,
  Close
} from "@mui/icons-material";
import AssessmentIcon from "@mui/icons-material/Assessment";
import PersonIcon from "@mui/icons-material/Person";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import DownloadIcon from "@mui/icons-material/Download";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import BlockIcon from "@mui/icons-material/Block";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import PeopleIcon from "@mui/icons-material/People";
// components
import Page from "../components/Page";
import { MemberForm } from "../components/Form/Member";
import {
  GetAllMember,
  fetchChaptList,
  fetchPinList,
  fetchallcitylist,
  fetchchapterbyuser,
  fetchmemberfeehistory,
  getPinBadgeByMemberId,
  handleDownload
} from "src/utils/common";
import {
  GetMemberById,
  UpdateMemberStatus,
  assginPinFunction,
  getMemberConnectedandBlockList,
  getMemberDeactiveReason,
  getMemberVerificationHistoryApi,
  getPinBadge,
  updateMemberVerificationStatus,
  userLogout,
  updateConnectionRequestMailStatus
} from "src/api/commonapi";
import { notification } from "src/utils/messages";
import { display, height } from "@mui/system";
import Select from "react-select";
import Modal from "@mui/material/Modal";
import { CSVLink } from "react-csv";
import { DatePicker, DateTimePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import moment from "moment";
import { fa, tr } from "faker/lib/locales";
import ChapterSelectDropDown from "src/components/ChapterSelectDropDown";
import { ClearIcon } from "@mui/x-date-pickers";
import { invoiceTypeFilter, IsNotValue } from "src/constant/variable";
import { useLocation, useNavigate } from "react-router-dom";
import CustomLoader from "src/commonComponents/CustomLoader";
import MemberProfileModal from "./MemberProfile";
import HandshakeIcon from "@mui/icons-material/Handshake";
import InductedMemberProfileModal from "./InductedMemberProfileModal";
import InvoiceDownloadForm from "./InvoiceDownloadForm";
import { Routes } from "src/constant/api_url";

export default function Member() {
  let loginUser = JSON.parse(localStorage.getItem("userData"));
  const navigate = useNavigate();

  const { state } = useLocation();

  const gender = [
    { label: "All", value: -1 },
    { label: "Not Selected", value: 0 },
    { label: "Male", value: 1 },
    { label: "Female", value: 2 }
  ];

  const locationType = [
    { label: "All", value: -1 },
    { label: "Location Set", value: 0 },
    { label: "Location Not Set", value: 1 }
  ];

  const [isLoading, setIsLoading] = useState(false);

  const [step, setStep] = useState(1);
  const [citylist, setcitylist] = useState([]);
  const [memberlist, setmemberlist] = useState([]);
  const [memberProfileId, setMemberProfileId] = useState(null);
  const [memberProfileModal, setMemberProfileModal] = useState(false);
  const [editMember, setEditMemberData] = useState(null);
  const [statusresp, setstatusresp] = useState(0);
  const [chaptlist, setchaplist] = useState([]);
  const [newMemeberList, setNewMemberList] = useState([]);
  const [activeMembercnt, setactiveMembercnt] = useState(0);
  const [deactiveMembercnt, setdeactiveMembercnt] = useState(0);
  const [directorcnt, setdirectorcnt] = useState(0);
  const [memberfeeModal, setmemberfeeModal] = useState(false);
  const [memberDeActiveModal, setmemberDeActiveModal] = useState(false);
  const [memberfeedata, setmemberfeedata] = useState([]);
  const [otherInvoiceList, setOtherInvoiceList] = useState([]);
  const [feeModalTab, setFeeModalTab] = useState(0);
  const [isFeeLoading, setIsFeeLoading] = useState(false);
  const [filterOption, setFilterOption] = useState([{ value: 0, label: "All Chapters" }]);
  const [activeSection, setActiveSection] = useState(1);
  const [historyData, setHistoryData] = useState([]);
  const [inductedMemberProfileModal, setInductedMemberProfileModal] = useState(false);
  const [isInvoiceGenerated, setIsInvoiceGenerated] = useState(false);

  const [memberdeactiveReasons, setMemberdeactiveReasons] = useState({
    m_id: "",
    status: "",
    reasons: "",
    deactivation_date: null
  });

  const [filter, setFilter] = useState({
    defaulselect: { value: 0, label: "All Chapters" },
    chpt_id: 0
  });
  const [seeMemberDeActiveModal, setSeeMemberDeActiveModal] = useState(false);
  const [getMemberConnectedListData, setMemberConnectedList] = useState([]);
  const [getMemberBlockListData, setMemberBlockList] = useState([]);
  const [connectedBlockModalOpen, setConnectedBlockModalOpen] = useState(false);
  const [connectedBlockTab, setConnectedBlockTab] = useState(0);
  const [connectionMailMemberId, setConnectionMailMemberId] = useState(null);
  const [conMailStatus, setConMailStatus] = useState(0);
  const [generateInvoiceModal, setGenerateInvoiceModal] = useState(false);
  const [leadDetails, setLeadDetails] = useState({});

  const [deActivateReasonData, setDeActivateReasonData] = useState({
    memberName: "",
    deActivationDate: "",
    deActivationReason: ""
  });

  const [filtereddata, setFilteredData] = useState({
    filterchap: 0,
    filtermember: "",
    gender: -1,
    invoice: -1,
    locationType: -1,
    startDate: state?.startDate ? moment(state.startDate, "DD-MM-YYYY").toDate() : null,
    endDate: state?.endDate ? moment(state.endDate, "DD-MM-YYYY").toDate() : null,
    search_date_type: state?.search_date_type ?? 0,
    activeMemberSearchType: state?.activeMemberSearchType ?? 0,
    activePositionType: 0,
    activeMemberTickType: state?.activeMemberTickType || [-1],
    filterCity:
      loginUser?.u_type == 1 ||
        (loginUser?.u_type == 2 && loginUser?.p_user_id != 1 && loginUser?.management_p == 1)
        ? loginUser?.city_id
        : state?.city || 0
  });
  const [showfilterdata, setShowFilterdata] = useState(false);
  const [achievementModal, setAchievementModal] = useState(false);
  const [memberVerificationModal, setMemberVerificationModal] = useState(false); //
  const toggleAchievementModal = () => setAchievementModal(!achievementModal);
  const toggleMemberProfileModal = () => setMemberProfileModal(!memberProfileModal);
  const toggleInductedMemberProfileModal = () =>
    setInductedMemberProfileModal(!inductedMemberProfileModal);
  const filterData = (returnFilterData = false) => {
    let selectedCityChapter =
      chaptlist &&
      chaptlist
        ?.map((chpt) => {
          if (filtereddata?.filterCity != 0) {
            if (chpt?.city_id == filtereddata?.filterCity) {
              return chpt.chpt_id;
            }
          } else {
            return chpt.chpt_id;
          }
        })
        .filter((f) => f != undefined);

    let nmember = [];
    nmember =
      memberlist &&
      memberlist?.filter((member) => {
        if (
          (member?.chpt_id == filtereddata?.filterchap ||
            filtereddata?.filterchap == 0 ||
            (member.launch_director != null &&
              member.launch_director_at == filtereddata?.filterchap) ||
            (member.support_director != null &&
              member.support_director_at == filtereddata?.filterchap)) &&
          selectedCityChapter.length != 0 &&
          selectedCityChapter.includes(member.chpt_id) &&
          (filtereddata?.activeMemberSearchType == 0
            ? member.status == 0 || member.status == 1
            : filtereddata?.activeMemberSearchType == 1
              ? member.status == 1
              : member.status == 0) &&
          (!filtereddata?.activeMemberTickType ||
            filtereddata.activeMemberTickType.length === 0 ||
            filtereddata.activeMemberTickType.includes(-1) ||
            // Direct match with m_verify_status == 1 or 2
            (filtereddata.activeMemberTickType.includes(1) && member.m_verify_status === 1) ||
            (filtereddata.activeMemberTickType.includes(2) && member.m_verify_status === 2) ||
            // Not OBT || Not Green Tick || Not Blue Tick
            (filtereddata.activeMemberTickType.includes(5) &&
              member.obt_approve == 0 &&
              member.m_verify_status == 4) ||
            (filtereddata.activeMemberTickType.includes(6) &&
              member.obt_approve === 1 &&
              member.m_verify_status != 1 &&
              member.m_verify_status != 2) ||
            (filtereddata.activeMemberTickType.includes(7) && member.m_verify_status == 1) ||
            // Match m_verify_status == 0 and OBT not approved
            (filtereddata.activeMemberTickType.includes(0) &&
              member.m_verify_status === 0 &&
              member.obt_approve === 0) ||
            (filtereddata.activeMemberTickType.includes(0) &&
              member.m_verify_status === 4 &&
              member.obt_approve === 0) ||
            // Match m_verify_status == 0 and OBT approved
            (filtereddata.activeMemberTickType.includes(4) &&
              member.m_verify_status === 0 &&
              member.obt_approve === 1)) &&
          // (filtereddata?.activeMemberTickType.length == 0 ||
          //   filtereddata?.activeMemberTickType.includes(-1) ||
          //   filtereddata?.activeMemberTickType.includes(member.m_verify_status))

          (filtereddata?.activePositionType == 0
            ? member?.type == -1 ||
            member?.type == 0 ||
            member?.type == 1 ||
            member?.type == 2 ||
            member?.type == 3 ||
            member?.type == 4 ||
            member?.type == 5
            : filtereddata?.activePositionType == 1
              ? member.type == 1 || member.type == 2 || member.type == 3 || member.type == 4
              : filtereddata?.activePositionType == 2
                ? (member.launch_director != null &&
                  (member.launch_director_at == filtereddata?.filterchap ||
                    filtereddata?.filterchap == 0)) ||
                (member.support_director != null &&
                  (member.support_director_at == filtereddata?.filterchap ||
                    filtereddata?.filterchap == 0))
                : member.type == -1 ||
                member.type == 0 ||
                member.type == 1 ||
                member.type == 2 ||
                member.type == 3 ||
                member.type == 4 ||
                member.type == 5) &&
          (filtereddata?.gender === -1 || member.gender == filtereddata?.gender) &&
          (filtereddata?.invoice === -1 ||
            (filtereddata?.invoice === 0 && member?.last_i_id === 0) ||
            (filtereddata?.invoice === 1 && member?.last_i_id > 0)) &&
          (filtereddata?.locationType === -1 ||
            (filtereddata?.locationType === 0 &&
              member?.lat_id != null &&
              member?.lang_id != null &&
              member?.lat_id !== "" &&
              member?.lang_id !== "") ||
            (filtereddata?.locationType === 1 &&
              (member?.lat_id == null ||
                member?.lang_id == null ||
                member?.lat_id === "" ||
                member?.lang_id === ""))) &&
          (member.m_name?.toLowerCase().includes(filtereddata?.filtermember?.toLowerCase()) ||
            (member.m_email_id || "")
              ?.toLowerCase()
              .includes(filtereddata?.filtermember?.toLowerCase()) ||
            member.business_name
              ?.toLowerCase()
              .includes(filtereddata?.filtermember?.toLowerCase()) ||
            member.business_category
              ?.toLowerCase()
              .includes(filtereddata?.filtermember?.toLowerCase()) ||
            member.mobile_no?.toLowerCase().includes(filtereddata?.filtermember?.toLowerCase()))
        ) {
          return member;
        }
      });
    // setNewMemberList(nmember);
    // setactivedeactive(nmember);

    if (returnFilterData == true) {
      return nmember;
    } else {
      setNewMemberList(nmember);
      setactivedeactive(nmember);
    }
  };

  useEffect(() => {
    if (state?.activeMemberTickType) {
      setFilteredData((prev) => ({
        ...prev,
        activeMemberTickType: state.activeMemberTickType || [-1]
      }));
    }
  }, [state?.activeMemberTickType]);

  const FilterDateWise = async () => {
    let selectedCityChapter =
      chaptlist &&
      chaptlist
        ?.map((chpt) => {
          if (filtereddata?.filterCity != 0) {
            if (chpt?.city_id == filtereddata?.filterCity) {
              return chpt.chpt_id;
            }
          } else {
            return chpt.chpt_id;
          }
        })
        .filter((f) => f != undefined);

    let nmember = [];
    if (filtereddata.startDate != null && filtereddata.endDate != null) {
      let start = "";
      let end = "";
      nmember =
        memberlist &&
        memberlist.filter((member) => {
          if (filtereddata?.filterchap != 0) {
            if (
              member.joining_date != "" &&
              member.due_date != "" &&
              member.deactivation_date != "" &&
              member.chpt_id == filtereddata?.filterchap
            ) {
              if (
                (member.chpt_id == filtereddata?.filterchap ||
                  filtereddata?.filterchap == 0 ||
                  (member.launch_director != null &&
                    member.launch_director_at == filtereddata?.filterchap) ||
                  (member.support_director != null &&
                    member.support_director_at == filtereddata?.filterchap)) &&
                selectedCityChapter.length != 0 &&
                selectedCityChapter.includes(member.chpt_id) &&
                (filtereddata?.activeMemberSearchType == 0
                  ? member.status == 0 || member.status == 1
                  : filtereddata?.activeMemberSearchType == 1
                    ? member.status == 1
                    : member.status == 0) &&
                (!filtereddata?.activeMemberTickType ||
                  filtereddata.activeMemberTickType.length === 0 ||
                  filtereddata.activeMemberTickType.includes(-1) ||
                  // Direct match with m_verify_status == 1 or 2
                  (filtereddata.activeMemberTickType.includes(1) && member.m_verify_status === 1) ||
                  (filtereddata.activeMemberTickType.includes(2) && member.m_verify_status === 2) ||
                  // Not OBT || Not Green Tick || Not Blue Tick
                  (filtereddata.activeMemberTickType.includes(5) &&
                    member.obt_approve == 0 &&
                    member.m_verify_status == 4) ||
                  (filtereddata.activeMemberTickType.includes(6) &&
                    member.obt_approve == 1 &&
                    member.m_verify_status != 1 &&
                    member.m_verify_status != 2) ||
                  (filtereddata.activeMemberTickType.includes(7) && member.m_verify_status == 1) ||
                  // Match m_verify_status == 0 and OBT not approved
                  (filtereddata.activeMemberTickType.includes(0) &&
                    member.m_verify_status === 0 &&
                    member.obt_approve === 0) ||
                  (filtereddata.activeMemberTickType.includes(0) &&
                    member.m_verify_status === 4 &&
                    member.obt_approve === 0) ||
                  // Match m_verify_status == 0 and OBT approved
                  (filtereddata.activeMemberTickType.includes(4) &&
                    member.m_verify_status === 0 &&
                    member.obt_approve === 1)) &&
                // (filtereddata?.activeMemberTickType.length == 0 ||
                //   filtereddata?.activeMemberTickType.includes(-1) ||
                //   filtereddata?.activeMemberTickType.includes(member.m_verify_status)) &&

                (filtereddata?.activePositionType == 0
                  ? member.type == -1 ||
                  member.type == 0 ||
                  member.type == 1 ||
                  member.type == 2 ||
                  member.type == 3 ||
                  member.type == 4 ||
                  member.type == 5
                  : filtereddata.activePositionType == 1
                    ? member.type == 1 || member.type == 2 || member.type == 3 || member.type == 4
                    : filtereddata?.activePositionType == 2
                      ? (member.launch_director != null &&
                        (member.launch_director_at == filtereddata?.filterchap ||
                          filtereddata?.filterchap == 0)) ||
                      (member.support_director != null &&
                        (member.support_director_at == filtereddata?.filterchap ||
                          filtereddata?.filterchap == 0))
                      : member.type == -1 ||
                      member.type == 0 ||
                      member.type == 1 ||
                      member.type == 2 ||
                      member.type == 3 ||
                      member.type == 4 ||
                      member.type == 5) &&
                (filtereddata?.gender === -1 || member.gender == filtereddata?.gender) &&
                (filtereddata?.invoice === -1 ||
                  (filtereddata?.invoice === 0 && member?.last_i_id === 0) ||
                  (filtereddata?.invoice === 1 && member?.last_i_id > 0)) &&
                (filtereddata?.locationType === -1 ||
                  (filtereddata?.locationType === 0 &&
                    member?.lat_id != null &&
                    member?.lang_id != null &&
                    member?.lat_id !== "" &&
                    member?.lang_id !== "") ||
                  (filtereddata?.locationType === 1 &&
                    (member?.lat_id == null ||
                      member?.lang_id == null ||
                      member?.lat_id === "" ||
                      member?.lang_id === ""))) &&
                (member.m_name?.toLowerCase().includes(filtereddata?.filtermember?.toLowerCase()) ||
                  member.business_name
                    ?.toLowerCase()
                    .includes(filtereddata?.filtermember?.toLowerCase()) ||
                  member.mobile_no
                    ?.toLowerCase()
                    .includes(filtereddata?.filtermember?.toLowerCase())) &&
                moment(
                  filtereddata.search_date_type == 0
                    ? member.joining_date
                    : filtereddata.search_date_type == 1
                      ? member.due_date
                      : member.deactivation_date,
                  "DD-MM-YYYY"
                ).isBetween(filtereddata.startDate, filtereddata.endDate, "days", "[]")
              ) {
                return member;
              }
            }
          } else {
            if (
              (filtereddata.search_date_type == 0 && member.joining_date != "") ||
              (filtereddata.search_date_type == 1 && member.due_date != "") ||
              (filtereddata.search_date_type == 2 && member.deactivation_date != "")
            ) {
              if (
                (member.chpt_id == filtereddata?.filterchap ||
                  filtereddata?.filterchap == 0 ||
                  (member.launch_director != null &&
                    member.launch_director_at == filtereddata?.filterchap) ||
                  (member.support_director != null &&
                    member.support_director_at == filtereddata?.filterchap)) &&
                selectedCityChapter.length != 0 &&
                selectedCityChapter.includes(member.chpt_id) &&
                (filtereddata?.activeMemberSearchType == 0
                  ? member.status == 0 || member.status == 1
                  : filtereddata?.activeMemberSearchType == 1
                    ? member.status == 1
                    : member.status == 0) &&
                (!filtereddata?.activeMemberTickType ||
                  filtereddata.activeMemberTickType.length === 0 ||
                  filtereddata.activeMemberTickType.includes(-1) ||
                  // Direct match with m_verify_status == 1 or 2
                  (filtereddata.activeMemberTickType.includes(1) && member.m_verify_status === 1) ||
                  (filtereddata.activeMemberTickType.includes(2) && member.m_verify_status === 2) ||
                  // Not OBT || Not Green Tick || Not Blue Tick
                  (filtereddata.activeMemberTickType.includes(5) &&
                    member.obt_approve == 0 &&
                    member.m_verify_status == 4) ||
                  (filtereddata.activeMemberTickType.includes(6) &&
                    member.obt_approve == 1 &&
                    member.m_verify_status != 1 &&
                    member.m_verify_status != 2) ||
                  (filtereddata.activeMemberTickType.includes(7) && member.m_verify_status == 1) ||
                  // Match m_verify_status == 0 and OBT not approved
                  (filtereddata.activeMemberTickType.includes(0) &&
                    member.m_verify_status === 0 &&
                    member.obt_approve === 0) ||
                  // Match m_verify_status == 0 and OBT approved
                  (filtereddata.activeMemberTickType.includes(4) &&
                    member.m_verify_status === 0 &&
                    member.obt_approve === 1)) &&
                // (filtereddata?.activeMemberTickType.length == 0 ||
                //   filtereddata?.activeMemberTickType.includes(-1) ||
                //   filtereddata?.activeMemberTickType.includes(member.m_verify_status)) &&

                (filtereddata?.activePositionType == 0
                  ? member.type == -1 ||
                  member.type == 0 ||
                  member.type == 1 ||
                  member.type == 2 ||
                  member.type == 3 ||
                  member.type == 4 ||
                  member.type == 5
                  : filtereddata.activePositionType == 1
                    ? member.type == 1 || member.type == 2 || member.type == 3 || member.type == 4
                    : filtereddata?.activePositionType == 2
                      ? (member.launch_director != null &&
                        (member.launch_director_at == filtereddata?.filterchap ||
                          filtereddata?.filterchap == 0)) ||
                      (member.support_director != null &&
                        (member.support_director_at == filtereddata?.filterchap ||
                          filtereddata?.filterchap == 0))
                      : member.type == -1 ||
                      member.type == 0 ||
                      member.type == 1 ||
                      member.type == 2 ||
                      member.type == 3 ||
                      member.type == 4 ||
                      member.type == 5) &&
                (filtereddata?.gender === -1 || member.gender == filtereddata?.gender) &&
                (filtereddata?.invoice === -1 ||
                  (filtereddata?.invoice === 0 && member?.last_i_id === 0) ||
                  (filtereddata?.invoice === 1 && member?.last_i_id > 0)) &&
                (filtereddata?.locationType === -1 ||
                  (filtereddata?.locationType === 0 &&
                    member?.lat_id != null &&
                    member?.lang_id != null &&
                    member?.lat_id !== "" &&
                    member?.lang_id !== "") ||
                  (filtereddata?.locationType === 1 &&
                    (member?.lat_id == null ||
                      member?.lang_id == null ||
                      member?.lat_id === "" ||
                      member?.lang_id === ""))) &&
                (member.m_name?.toLowerCase().includes(filtereddata?.filtermember?.toLowerCase()) ||
                  member.business_name
                    ?.toLowerCase()
                    .includes(filtereddata?.filtermember?.toLowerCase()) ||
                  member.mobile_no
                    ?.toLowerCase()
                    .includes(filtereddata?.filtermember?.toLowerCase())) &&
                moment(
                  filtereddata.search_date_type == 0
                    ? member.joining_date
                    : filtereddata.search_date_type == 1
                      ? member.due_date
                      : member.deactivation_date,
                  "DD-MM-YYYY"
                ).isBetween(filtereddata.startDate, filtereddata.endDate, "days", "[]")
              ) {
                return member;
              }
            }
          }
        });
      setNewMemberList(nmember);
      setactivedeactive(nmember);
    } else {
      // let notify = notification({
      //   type: "error",
      //   message: "Please Check Start Date And End Date",
      // });
      // notify();
    }
  };
  const setactivedeactive = (newMemeberList) => {
    let actcnt = 0;
    let deactcnt = 0;
    let dircnt = 0;

    newMemeberList?.map((e, key) => {
      if (
        (e.launch_director_at == filtereddata?.filterchap ||
          e.support_director_at == filtereddata?.filterchap ||
          filtereddata.filterchap == 0) &&
        (e.launch_director != null || e.support_director != null)
      ) {
        dircnt = dircnt + 1;
      } else if (e.status == 0) {
        deactcnt = deactcnt + 1;
      } else if (e.status == 1) {
        actcnt = actcnt + 1;
      }
    });
    setactiveMembercnt(actcnt);
    setdeactiveMembercnt(deactcnt);
    setdirectorcnt(dircnt);
  };

  const getChapterList = async () => {
    let newChptOption = [{ chpt_id: 0, chpt_name: "All" }];
    let res = await fetchchapterbyuser(loginUser.city_id, loginUser.u_type);
    res?.map((e) => {
      newChptOption.push({
        ...e
      });
    });

    setchaplist(newChptOption);
  };

  useEffect(async () => {
    // getChapterList();
    setIsLoading(true);
    setchaplist(await fetchchapterbyuser(loginUser.city_id, loginUser.u_type));

    setmemberlist(await GetAllMember(loginUser.city_id, loginUser.u_type));
    setIsLoading(false);
  }, [step, statusresp, isInvoiceGenerated]);

  useEffect(async () => {
    if (
      (filtereddata.filterchap != undefined ||
        filtereddata?.filtermember != undefined ||
        filtereddata.startDate != null ||
        filtereddata.endDate != null) &&
      chaptlist?.length > 0
    ) {
      await filterData();
      await FilterDateWise();
    }
  }, [filtereddata, memberlist, chaptlist]);

  useEffect(async () => {
    chaptlist.map((option) => {
      filterOption.push({ value: option.chpt_id, label: option.chpt_name });
    });
  }, [chaptlist]);

  const changestatus = async (m_id, status, mobile_no, reason = "", date = null) => {
    let fdata = new FormData();
    fdata.append("m_id", m_id);
    fdata.append("status", status);
    fdata.append("reason", reason);
    fdata.append("deactivation_date", moment(date).format("DD-MM-YYYY"));
    fdata.append("mobile_no", mobile_no);
    fdata.append("u_id", loginUser.u_id);

    if (
      (status == 0 &&
        reason != "" &&
        date != null &&
        moment(date).format("DD-MM-YYYY") != "Invalid date") ||
      (status == 1 && reason == "")
    ) {
      setIsLoading(true);
      const resp = await UpdateMemberStatus(fdata);
      setIsLoading(false);
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      notify();

      if (resp.status == 1) {
        setstatusresp(statusresp + 1);
        setMemberdeactiveReasons({
          m_id: "",
          status: "",
          reasons: ""
        });
        setmemberDeActiveModal(false);
      }
    } else {
      let notify = notification({
        type: "error",
        message: "Please Check Reason Or Date And Try Again"
      });
      notify();
    }
  };

  const getmemberfeehistory = async (m_id) => {
    setIsFeeLoading(true);
    setFeeModalTab(0);
    const resp = await fetchmemberfeehistory(m_id);
    setmemberfeedata(resp?.fees_list || []);
    setOtherInvoiceList(resp?.other_invoice_list || []);
    setIsFeeLoading(false);
  };

  const ulogout = async (m_id) => {
    const resp = await userLogout(m_id);

    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();

    if (resp.status == 1) {
      setstatusresp(statusresp + 1);
    }
  };

  const getmember = async (id) => {
    const response = await GetMemberById(id);
    setEditMemberData(response.data);
    setStep(3);
  };

  const [memberVerificationData, setMemberVerificationData] = useState({
    m_id: "",
    isOBT: false,
    isV2V: false,
    isMGT: false,
    obt_approve_date: null,
    date: null,
    blue_tick_assign_date: null
  });

  // const removeMemberVeification = async (memberId, m_verify_status) => {
  //   let resp = await updateMemberVerificationStatus({
  //     member_id: memberId,
  //     status: m_verify_status,
  //     date: null,
  //   });

  //   if (resp.status == 1) {
  //     setstatusresp(statusresp + 1);
  //     setMemberVerificationData({
  //       m_id: "",
  //       m_verify_status: "",
  //       date: null,
  //       blue_tick_assign_date: null,
  //     });
  //     setMemberVerificationModal(false);
  //   }
  //   let notify = notification({
  //     type: resp.status == 0 ? "error" : "success",
  //     message: resp.message,
  //   });
  //   notify();
  // };

  // const changeGreenVerify = async () => {
  //   console.log("memberVerificationData", memberVerificationData);
  //   if (
  //     memberVerificationData.m_verify_status == 0 ||
  //     (memberVerificationData.m_verify_status == 0 &&
  //       memberVerificationData?.obt_approve != 1 &&
  //       memberVerificationData?.obt_approve_date != "" &&
  //       memberVerificationData?.obt_approve_date != null) ||
  //     (memberVerificationData.m_verify_status == 1 &&
  //       memberVerificationData?.date != "" &&
  //       memberVerificationData?.date != null) ||
  //     (memberVerificationData.m_verify_status == 2 &&
  //       memberVerificationData?.blue_tick_assign_date != "" &&
  //       memberVerificationData?.blue_tick_assign_date != null)
  //   ) {
  //     let resp = await updateMemberVerificationStatus({
  //       member_id: memberVerificationData?.m_id,
  //       status: memberVerificationData?.m_verify_status,
  //       date: memberVerificationData?.date,
  //       blue_tick_assign_date: memberVerificationData?.blue_tick_assign_date,
  //       obt_approve: memberVerificationData?.obt_approve,
  //       obt_approve_date: memberVerificationData?.obt_approve_date
  //     });
  //     if (resp.status == 1) {
  //       setstatusresp(statusresp + 1);
  //       setMemberVerificationData({
  //         m_id: "",
  //         m_verify_status: "",
  //         date: null,
  //         blue_tick_assign_date: null,
  //         // obt_approve: 0,
  //         obt_approve_date: null
  //       });
  //       setMemberVerificationModal(false);
  //     }

  //     let successMessage = ``;

  //     // if admin
  //     if (
  //       !(
  //         loginUser?.u_type == 0 ||
  //         (loginUser?.u_type == 2 && loginUser?.p_user_id == 1 && loginUser?.management_p != 0)
  //       )
  //     ) {
  //       successMessage = `Member  ${
  //         memberVerificationData?.m_verify_status == 1
  //           ? "OBT Compeleted "
  //           : memberVerificationData?.m_verify_status == 2
  //           ? "MGT Compeleted"
  //           : "OBT Removed"
  //       } Successfully`;
  //     } else {
  //       // if city amb
  //       successMessage = `Member  ${
  //         memberVerificationData?.m_verify_status == 1
  //           ? "OBT Compeleted "
  //           : memberVerificationData?.m_verify_status == 2
  //           ? "MGT Compeleted"
  //           : "OBT/MGT Removed"
  //       } Successfully`;
  //     }

  //     let notify = notification({
  //       type: resp.status == 0 ? "error" : "success",
  //       message: resp.status == 0 ? resp.message : successMessage
  //     });
  //     notify();
  //   } else {
  //     let notify = notification({
  //       type: "error",
  //       message: "Please Enter Member Verification Date"
  //     });
  //     notify();
  //   }
  // };
  const changeGreenVerify = async () => {
    let m_verify_status = "";
    if (memberVerificationData.isMGT) m_verify_status = 2;
    else if (memberVerificationData.isV2V) m_verify_status = 1;
    else if (memberVerificationData.isOBT) m_verify_status = 0;
    else m_verify_status = 4;

    const payload = {
      updated_by: loginUser?.u_id,
      member_id: memberVerificationData.m_id,
      status: m_verify_status,
      obt_approve: memberVerificationData.isOBT ? 1 : 0,
      obt_approve_date: memberVerificationData.obt_approve_date,
      date: memberVerificationData.date,
      blue_tick_assign_date: memberVerificationData.blue_tick_assign_date
    };

    setIsLoading(true);
    const resp = await updateMemberVerificationStatus(payload);
    setIsLoading(false);
    if (resp.status == 1) {
      // reset on success
      setMemberVerificationData({
        m_id: "",
        isOBT: false,
        isV2V: false,
        isMGT: false,
        obt_approve_date: null,
        date: null,
        blue_tick_assign_date: null
      });
      setMemberVerificationModal(false);
      setstatusresp((prev) => prev + 1);
    }

    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.status == 1 ? resp.message : ""
    });
    notify();
  };

  const export_columns_pinAssign = [
    { label: "Pin Name", key: "name" },
    { label: "Pin Assign Date", key: "date" }
  ];
  const expo_columns = [
    { label: "No", key: "m_id" },
    { label: "Member Name", key: "m_name" },
    { label: "Chapter Name", key: "chpt_name" },
    { label: "Contact No", key: "mobile_no" },
    { label: "Email", key: "m_email_id" },
    {
      label: "Join Date",
      key: "joining_date"
    },
    {
      label: "Expire Date",
      key: "due_date"
    },
    { label: "Business Name", key: "business_name" },
    { label: "Business Category", key: "business_category" },
    { label: "Status", key: "Current_Status" },
    { label: "Director At", key: "combined_director" },
    { label: "Member Position", key: "member_new_position" },
    { label: "Member Refer By", key: "member_referal_by" },
    { label: "Deactivation Date", key: "deactivation_date" },
    { label: "Deactivation Reason", key: "reason" },
    { label: "OBT Complete Date", key: "m_verify_date" },
    { label: "MGT Complete Date", key: "blue_tick_assign_date" },
    { label: "ConnectedList", key: "ConnectedList" },
    { label: "BlockedList", key: "BlockedList" }
  ];

  const expo_columns_Additional = [
    { label: "No", key: "m_id" },
    { label: "Member Name", key: "m_name" },
    { label: "Chapter Name", key: "chpt_name" },
    { label: "Contact No", key: "mobile_no" },
    { label: "Email", key: "m_email_id" },
    { label: "Business Name", key: "business_name" },
    { label: "Business Category", key: "business_category" },
    { label: "Business Since", key: "business_since" },
    { label: "Business Description", key: "business_desc" },
    { label: "Business Address", key: "b_address" },
    { label: "Status", key: "Current_Status" },
    { label: "DOB", key: "dob" },
    { label: "Blood Group", key: "blood_group" },
    { label: "Member Position", key: "member_new_position" },
    { label: "Director At", key: "combined_director" },
    { label: "Website URL", key: "website_url" },
    { label: "Facebook URL", key: "fb" },
    { label: "Instagram URL", key: "instagram" },
    { label: "LinkedIn URL", key: "linkedin" },
    { label: "Twitter URL", key: "twitter" },
    { label: "YouTube URL", key: "youtube" },
    {
      label: "Join Date",
      key: "joining_date"
    },
    {
      label: "Expire Date",
      key: "due_date"
    },
    { label: "Reference By", key: "member_referal_by" },
    { label: "Deactivation Date", key: "deactivation_date" },
    { label: "Deactivation Reason", key: "reason" },
    { label: "OBT Complete Date", key: "m_verify_date" },
    { label: "MGT Complete Date", key: "blue_tick_assign_date" },
    { label: "ConnectedList", key: "ConnectedList" },
    { label: "BlockedList", key: "BlockedList" }
  ];

  const exportMemberList = newMemeberList.map((member) => ({
    ...member,
    reason: member.member_deactive_reason != null ? member.member_deactive_reason : member.reason,
    ConnectedList: Array.isArray(member.connectedMember)
      ? member.connectedMember.map((c) => `${c.m_name} (${c.chpt_name})`).join(" || ")
      : "",
    BlockedList: Array.isArray(member.blockedMember)
      ? member.blockedMember.map((b) => `${b.m_name} (${b.chpt_name})`).join(" || ")
      : ""
  }));

  const conditionalRowStyles = [
    {
      when: (row) => row.member_deleted === 1,
      style: {
        backgroundColor: "rgba(255, 0, 0, 0.2)", // light red background
        color: "black"
      }
    }
  ];

  const columns = [
    {
      name: "Id",
      selector: (row) => row.m_id,
      sortable: true,
      wrap: true,
      width: "100px"
    },
    {
      name: "Report",
      wrap: true,
      width: "100px",
      cell: (row) => (
        <>
          <Tooltip title="Chapter's Member Report">
            <IconButton
              onClick={() => {
                navigate("/chapters-member-report", {
                  state: row
                });
              }}
            >
              <AssessmentIcon color="warning" />
            </IconButton>
          </Tooltip>
        </>
      )
    },
    {
      name: "Member Name",
      wrap: true,
      selector: (row) => (
        <>
          {loginUser?.u_type == 0 || (loginUser?.u_type == 2 && loginUser?.p_user_id == 1 && loginUser?.management_p == 1) ? (
            <a
              style={{
                cursor: "pointer",
                overflow: "visible",
                whiteSpace: "pre-line"
              }}
              onClick={() => (setPinMemberActiveName(row?.m_name + " (" + row.business_name + ") [" + row.Current_Status + "]"), getMemberAchivementByMemberId(row.m_id, `${row.m_name} (${row.chpt_name})`), toggleAchievementModal())}
            >
              {row.m_name}
            </a>
          ) : (
            <Typography variant="body2" sx={{ fontWeight: 500, color: "#334155" }}>
              {row.m_name}
            </Typography>
          )}
        </>
      ),
      sortable: true
    },
    {
      name: "Chapter Name",
      wrap: true,
      selector: (row) => row.chpt_name,
      sortable: true
    },
    {
      name: "Position",
      wrap: true,
      width: "100px",

      selector: (row) => (
        <div style={{ overflow: "visible", whiteSpace: "pre-line" }}>
          {/* {row.type == 1
            ? "President"
            : row.type == 2
            ? "Vice President"
            : row.type == 3
            ? "ST"
            : row.type == 4
            ? "LVH"
            : row.type == 5
            ? "Support Director"
            : "Member"} */}
          {row.member_new_position}
          <br />
          {row.combined_director != null && " " + row.combined_director}
        </div>
      ),
      sortable: true
    },
    {
      name: "Member Email",
      wrap: true,
      width: "240px",
      selector: (row) => (
        <span
          style={{
            color: row.email_verify === 1 ? "green" : "red",
            fontWeight: 600
          }}
        >
          {!IsNotValue.includes(row.m_email_id) ? row.m_email_id : ""}
        </span>
      ),
      sortable: true
    },
    {
      name: "Business Name",
      selector: (row) => row.business_name,
      sortable: true,
      wrap: true,
      width: "150px"
    },
    {
      name: "Business Category",
      selector: (row) => row.business_category,
      sortable: true,
      wrap: true,
      width: "120px"
    },
    {
      name: "Contact No",
      wrap: true,
      width: "120px",

      selector: (row) => row.mobile_no
    },
    {
      name: "Reference By",
      wrap: true,
      selector: (row) => {
        return (
          <div title={row.member_referal_by != null && row.member_referal_by}>
            {row.member_referal_by != null ? row.member_referal_by : "-"}
          </div>
        );
      }
    },
    {
      name: "Gender",
      wrap: true,
      selector: (row) =>
        row.gender == 0 ? "Not Selected" : gender?.find((g) => g.value == row.gender)?.label || "-",
      sortable: true
    },
    {
      name: "Invoice Type",
      wrap: true,
      selector: (row) => (row.last_i_id == 0 ? "Not Generated" : "Generated" || "-"),
      sortable: true
    },
    {
      name: "Join Date",
      wrap: true,
      selector: (row) => row.joining_date
    },
    {
      name: "Expire Date",
      wrap: true,
      selector: (row) => row.due_date
    },
    {
      name: "Deactivate Date",
      wrap: true,
      selector: (row) => row.deactivation_date
    },
    {
      name: "OBT Complete Date",
      wrap: true,
      selector: (row) => row.obt_approve_date || "-"
    },
    {
      name: "Green Tick Enable Date",
      wrap: true,
      selector: (row) => row.m_verify_date || "-"
    },
    {
      name: "Blue Tick Enable Date",
      wrap: true,
      selector: (row) => row.blue_tick_assign_date || "-"
    },
    {
      name: "Status",
      wrap: true,
      width: "150px",
      selector: (row) => (
        <>
          {row.status == 1 ? (
            <>
              <div style={{ margin: "10px 0" }}>
                <Label
                  variant="ghost"
                  color="success"
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                    fontSize: "16px"
                  }}
                >
                  Active
                </Label>

                <Button
                  variant="contained"
                  onClick={() => {
                    setMemberdeactiveReasons({
                      m_id: row.m_id,
                      status: 0,
                      reason: ""
                    });

                    setmemberDeActiveModal(true);
                  }}
                  style={{ background: "#ff4842" }}
                >
                  Deactive
                </Button>
              </div>
            </>
          ) : (
            <>
              <div style={{ margin: "10px 0" }}>
                <Label
                  variant="ghost"
                  color="error"
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                    fontSize: "14px"
                  }}
                >
                  Deactive
                </Label>

                <Button
                  variant="contained"
                  disabled={row.member_deleted === 1}
                  onClick={() => {
                    changestatus(row.m_id, 1, row.mobile_no);
                  }}
                >
                  Active
                </Button>
              </div>
            </>
          )}
        </>
      )
    },
    {
      name: "Action",
      wrap: true,
      width: "400px",
      cell: (row) => (
        <>
          <div
            style={
              row.status == 1
                ? {
                  height: "20px",
                  width: "20px",
                  border: "2px Solid #000",
                  backgroundColor: "Green",
                  borderRadius: "50%",
                  marginRight: "5px"
                }
                : {
                  height: "20px",
                  width: "20px",
                  border: "2px Solid #000",
                  backgroundColor: "Red",
                  borderRadius: "50%",
                  marginRight: "5px"
                }
            }
          ></div>
          <Tooltip title="View Profile">
            <IconButton
              onClick={() => {
                setMemberProfileId(row?.m_id);
                toggleMemberProfileModal();
              }}
            >
              <PersonIcon color="primary" />
            </IconButton>
          </Tooltip>
          <Tooltip title="View Inducted Member">
            <IconButton
              onClick={() => {
                setMemberProfileId(row?.m_id);
                toggleInductedMemberProfileModal();
              }}
            >
              <HandshakeIcon color="primary" />
            </IconButton>
          </Tooltip>
          <a
            href="#"
            onClick={() => {
              getmember(row.m_id);
            }}
          >
            <Tooltip title="Edit Member">
              <IconButton>
                <EditSharp color="warning" />
              </IconButton>
            </Tooltip>
          </a>
          {row.status == 0 && (
            <a
              onClick={() => {
                setSeeMemberDeActiveModal(true);
                setDeActivateReasonData({
                  ...deActivateReasonData,
                  memberName: row.m_name + "(" + row.business_name + ")",
                  deActivationDate: row.deactivation_date,
                  deActivationReason:
                    row.member_deactive_reason != null ? row.member_deactive_reason : row.reason
                });
              }}
            >
              <Tooltip title="See Deactivate Reason">
                <IconButton>
                  <RemoveRedEye color="success" />
                </IconButton>
              </Tooltip>
            </a>
          )}
          <a
            onClick={() => {
              handleGetMemberConnectedandBlockList(row.m_id);
              // setSeeMemberDeActiveModal(true);
              // setDeActivateReasonData({
              //   ...deActivateReasonData,
              //   memberName: row.m_name + "(" + row.business_name + ")",
              //   deActivationDate: row.deactivation_date,
              //   deActivationReason:
              //     row.member_deactive_reason != null ? row.member_deactive_reason : row.reason
              // });
            }}
          >
            <Tooltip title="View Connected and Block List">
              <IconButton>
                <ListAlt color="secondary" />
              </IconButton>
            </Tooltip>
          </a>

          <a
            onClick={async () => {
              setmemberfeeModal(true);
              setLeadDetails(row);
              await getmemberfeehistory(row.m_id);
            }}
          >
            <Tooltip title="Member Fees">
              <IconButton>
                <CurrencyRupeeSharp color="info" />
              </IconButton>
            </Tooltip>
          </a>

          {(loginUser?.u_type == 0 || (loginUser?.u_type == 2 && loginUser?.p_user_id == 1 && loginUser?.management_p == 1)) && (
            <Tooltip title="Member Achievement">
              <span>
                <IconButton
                  disabled={row.member_deleted === 1}
                  onClick={() => (
                    setPinMemberActiveName(
                      row?.m_name + " (" + row.business_name + ") [" + row.Current_Status + "]"
                    ),
                    getMemberAchivementByMemberId(row.m_id, `${row.m_name} (${row.chpt_name})`),
                    toggleAchievementModal()
                  )}
                >
                  <EmojiEvents color="success" />
                </IconButton>
              </span>
            </Tooltip>
          )}

          {/* <a
            onClick={() => (
              setPinMemberActiveName(
                row?.m_name + " (" + row.business_name + ") [" + row.Current_Status + "]"
              ),
              getMemberAchivementByMemberId(row.m_id),
              toggleAchievementModal()
            )}
          >
            <Tooltip title="Member Achievement">
              <IconButton disabled={row.member_deleted === 1}>
                <EmojiEvents color="success" />
              </IconButton>
            </Tooltip>
          </a> */}
          {/* Member Verified */}
          <Tooltip title="Member Verification">
            <span>
              <IconButton
                disabled={row.member_deleted === 1}
                onClick={() => {
                  setMemberVerificationData({
                    m_id: row?.m_id || "",
                    isOBT: row?.obt_approve == 1,
                    isV2V: row?.greentick_approve == 1,
                    isMGT: row?.m_verify_status == 2,
                    obt_approve_date: row?.obt_approve_date || null,
                    date: row?.m_verify_date || null,
                    blue_tick_assign_date: row?.blue_tick_assign_date || null
                  });
                  setMemberVerificationModal(true);
                }}
              >
                <VerifiedUser
                  sx={{
                    color:
                      row?.m_verify_status == 4 && row?.obt_approve == 0
                        ? "error.main"
                        : row?.m_verify_status == 2
                          ? "#007bff"
                          : row?.m_verify_status == 0
                            ? row?.obt_approve == 1
                              ? "warning.main"
                              : "error.main"
                            : "success.main"
                  }}
                />
              </IconButton>
            </span>
          </Tooltip>

          {(loginUser?.u_type == 0 || (loginUser?.u_type == 2 && loginUser?.management_p == 1)) &&
            row?.last_i_id == 0 && (
              <Tooltip title="Generate Invoice">
                <span>
                  <IconButton
                    onClick={() => {
                      setGenerateInvoiceModal(true);
                      setLeadDetails(row);
                    }}
                  >
                    <ReceiptLongIcon
                      sx={{
                        color: "#1976d2", // primary blue
                        fontSize: 28
                      }}
                    />
                  </IconButton>
                </span>
              </Tooltip>
            )}
          {row?.last_i_id > 0 && (
            <Tooltip title="Download Invoice">
              <span>
                <IconButton
                  onClick={() => {
                    handleDownload(
                      `${Routes.API_HOSTNAME}invoice-pdf/${row?.invoice_url}`,
                      row?.invoice_url
                    );
                  }}
                >
                  <DownloadIcon
                    sx={{
                      color: "#1976d2", // primary blue
                      fontSize: 28
                    }}
                  />
                </IconButton>
              </span>
            </Tooltip>
          )}

          {/* <a
            onClick={() => {
              // if (row?.m_verify_status == 0) {
              setMemberVerificationData({
                m_id: row?.m_id || "",
                isOBT: row?.obt_approve == 1,
                isV2V: row?.greentick_approve == 1,
                isMGT: row?.m_verify_status == 2,
                obt_approve_date: row?.obt_approve_date || null,
                date: row?.m_verify_date || null,
                blue_tick_assign_date: row?.blue_tick_assign_date || null
              });
              setMemberVerificationModal(true);
              // } else {
              //   removeMemberVeification(
              //     row?.m_id,
              //     row?.m_verify_status == 0 ? 1 : 0
              //   );
              // }

              //
            }}
          >
            <Tooltip title="Member Verification">
              <IconButton disabled={row.member_deleted === 1}>
                <VerifiedUser
                  sx={{
                    color:
                      row?.m_verify_status == 4 && row?.obt_approve == 0
                        ? "error.main"
                        : row?.m_verify_status == 2
                        ? "#007bff"
                        : row?.m_verify_status == 0
                        ? row?.obt_approve == 1
                          ? "warning.main"
                          : "error.main"
                        : "success.main"
                  }}
                />
              </IconButton>
            </Tooltip>
          </a> */}
          {row.is_login == 1 ? (
            <a
              onClick={() => {
                ulogout(row.m_id);
              }}
            >
              <Tooltip title="Logout Member">
                <IconButton>
                  <LogoutSharp color="error" />
                </IconButton>
              </Tooltip>
            </a>
          ) : (
            ""
          )}
        </>
      )
    }
  ];

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  const cancelmemberDeActiveModal = () => {
    setmemberDeActiveModal(false);
    setMemberdeactiveReasons({
      m_id: "",
      status: "",
      reasons: "",
      deactivation_date: null
    });
  };
  const cancelModal = () => {
    setmemberfeeModal(false);
    setmemberfeedata([]);
    setOtherInvoiceList([]);
    setFeeModalTab(0);
  };

  const closeMemberDeActiveModal = () => {
    setSeeMemberDeActiveModal(false);
    setDeActivateReasonData({
      memberName: "",
      deActivationDate: "",
      deActivationReason: ""
    });
  };

  const memberType = [
    { label: "All", value: 0 },
    { label: "Active Member", value: 1 },
    { label: "De-Active Member", value: 2 }
  ];

  const memberPosition = [
    { label: "All", value: 0 },
    { label: "LT", value: 1 },
    { label: "Director", value: 2 },
    { label: "Member", value: 3 }
  ];

  const memberTick = [
    { label: "All", value: -1 },
    { label: "Not Approved", value: 0 },
    { label: "OBT Completed", value: 4 },
    { label: "Green Tick", value: 1 },
    { label: "Blue Tick", value: 2 },
    { label: "Not OBT Completed", value: 5 },
    { label: "Not Green Tick", value: 6 },
    { label: "Not Blue Tick", value: 7 }
  ];

  const [achievementOptions, setAchievementOption] = useState([]);
  const [pinMemberActiveName, setPinMemberActiveName] = useState("");
  const [memberSelecedAchievement, setMemberSelecedAchievement] = useState({
    m_id: "",
    m_name: "",
    achievement: []
  });
  const getAchivementOptions = async () => {
    const res = await fetchPinList(1);
    const activePins = (res || []).filter((p) => p.status == 1);
    setAchievementOption(activePins);
    setMemberSelecedAchievement((prev) => ({
      ...prev,
      achievement: activePins.map((achive) => ({
        p_id: achive.p_id,
        name: achive.name,
        date: null,
        check: false
      }))
    }));
  };

  useEffect(() => {
    getAchivementOptions();
  }, []);
  const getMemberAchivementByMemberId = async (memberId, memberName) => {
    if (!memberId) return;
    const resp = await getPinBadgeByMemberId(memberId);
    setMemberSelecedAchievement((prev) => ({
      m_id: memberId,
      m_name: memberName,
      achievement: prev.achievement.map((achievement) => {
        const foundItem = resp?.find((item) => item.p_id === achievement.p_id);
        return foundItem
          ? {
            ...achievement,
            name: foundItem.name,
            m_p_id: foundItem.m_p_id,
            date: foundItem.date,
            check: true
          }
          : { ...achievement, date: null, check: false };
      })
    }));
  };

  const handleAchievementSubmit = async () => {
    setIsLoading(true);
    console.log('handleAchievementSubmit', loginUser)
    let cityName = null;
    if (loginUser?.u_type == 1 ||
      (loginUser?.u_type == 2 && loginUser?.p_user_id != 1 && loginUser?.management_p == 1)) {
      cityName = citylist.find((city) => {
        return filtereddata.filterCity == city.city_id && {
          value: city.city_id,
          label: city.city_name
        }
      }).city_name
    }
    let resp = await assginPinFunction({ ...memberSelecedAchievement, city_name: cityName });
    setIsLoading(false);
    if (resp.status == 1) {
      setMemberSelecedAchievement({
        m_id: "",
        m_name: "",
        achievement: achievementOptions?.map((achive) => {
          return (
            achive.status == 1 && {
              name: achive.name,
              p_id: achive.p_id,
              check: false
            }
          );
        })
      });
      toggleAchievementModal();
    } else {
      toggleAchievementModal();
    }
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
  };
  const [checked, setChecked] = React.useState(true);
  const handleSwitchChange = (index) => {
    setMemberSelecedAchievement((prev) => {
      const updatedAchievement = prev.achievement.map((item, i) =>
        i === index ? { ...item, check: !item.check } : item
      );
      return { ...prev, achievement: updatedAchievement };
    });
  };
  const getallcitylist = async () => {
    setcitylist(await fetchallcitylist());
  };

  const [memberDeactivateReason, setMemberDeactivateReason] = useState([]);

  const getMemberDeactivateReasons = async () => {
    let res = await getMemberDeactiveReason();
    setMemberDeactivateReason(res);
  };

  const handleGetMemberConnectedandBlockList = async (m_id) => {
    try {
      const response = await getMemberConnectedandBlockList({ m_id });
      const connected = response?.data?.connectedMember ?? response?.connectedMember ?? [];
      const blocked = response?.data?.blockedMember ?? response?.blockedMember ?? [];
      setMemberConnectedList(connected);
      setMemberBlockList(blocked);
      setConnectedBlockTab(0);
      setConnectionMailMemberId(m_id);
      setConMailStatus(response?.data?.con_mail_status ?? 1);
      setConnectedBlockModalOpen(true);
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleToggleConnectionMail = async () => {
    const newStatus = conMailStatus === 1 ? 0 : 1;
    try {
      const resp = await updateConnectionRequestMailStatus({
        m_id: connectionMailMemberId,
        con_mail_status: newStatus
      });
      if (resp?.status === 1) {
        setConMailStatus(newStatus);
        let notify = notification({
          type: "success",
          message: resp.message || "Connection mail status updated"
        });
        notify();
      } else {
        let notify = notification({
          type: "error",
          message: resp?.message || "Failed to update"
        });
        notify();
      }
    } catch (error) {
      let notify = notification({
        type: "error",
        message: "Something went wrong"
      });
      notify();
    }
  };

  useEffect(async () => {
    getallcitylist();
    getMemberDeactivateReasons();
  }, []);

  const getMemberVerificationHistory = async () => {
    let res = await getMemberVerificationHistoryApi(memberVerificationData?.m_id);
    setHistoryData(res?.data);
  };

  useEffect(() => {
    if (activeSection === 2) getMemberVerificationHistory();
  }, [activeSection]);

  // Field name mapping
  const settingHistoryFieldName = {
    obt_approve: "Enable OBT",
    greentick_approve: "Enable Green Tick / V2V card Complete",
    obt_approve_date: "OBT Complete Date",
    m_verify_date: "V2V Complete Date",
    m_verify_status: "Enable Blue Tick / MGT Complete",
    blue_tick_assign_date: "MGT Complete Date"
  };

  // Value renderer
  const renderValue = (key, value) => {
    if (key === "m_verify_status") {
      return Number(value) === 2 ? "On" : "Off";
    }

    if (["obt_approve", "greentick_approve"].includes(key)) {
      return Number(value) === 1 ? "On" : "Off";
    }

    return value !== null && value !== undefined ? String(value) : "-";
  };

  return (
    <>
      <Modal
        open={memberVerificationModal}
        onClose={() => {
          setMemberVerificationData({
            m_id: "",
            isOBT: false,
            isV2V: false,
            isMGT: false,
            obt_approve_date: null,
            date: null,
            blue_tick_assign_date: null
          });
          setMemberVerificationModal(false);
          setActiveSection(1);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            style={{ textAlign: "center" }}
          >
            {/* Member Verification */}
            <Tabs value={activeSection} onChange={(e, val) => setActiveSection(val)} centered>
              <Tab label="Member Verification" value={1} />
              <Tab label="Member Verification History" value={2} />
            </Tabs>
          </Typography>

          <div style={{ padding: "10px" }}>
            <hr />
            <div style={{ maxHeight: "480px" }}>
              {activeSection === 1 && (
                <Stack spacing={10} style={{ marginBottom: "10px", marginTop: "10px" }}>
                  <Stack spacing={10} style={{ marginBottom: "15px" }}>
                    {/* For Now Blue Tick Removed from city AMB */}
                    {/* When wver the client will ask for add again then remove the below grid code with login  loginUser?.u_type == 0 ||
                      (loginUser?.u_type == 2 &&
                        loginUser?.p_user_id == 1 &&
                        loginUser?.management_p != 0) */}
                    <Grid container spacing={1}>
                      {/* {!(
                      loginUser?.u_type == 0 ||
                      (loginUser?.u_type == 2 &&
                        loginUser?.p_user_id == 1 &&
                        loginUser?.management_p != 0)
                    ) && <Grid item xs={3}></Grid>} */}

                      <Grid item xs={6}>
                        <Stack>
                          <FormControl component="fieldset">
                            <FormLabel component="legend">Enable OBT</FormLabel>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={memberVerificationData.isOBT}
                                    onChange={(e) => {
                                      setMemberVerificationData({
                                        ...memberVerificationData,
                                        isOBT: e.target.checked
                                      });
                                    }}
                                  />
                                }
                                label="Enable OBT"
                              />
                            </FormGroup>
                          </FormControl>
                          <Stack spacing={3} style={{ marginTop: "15px" }}>
                            <LocalizationProvider
                              dateAdapter={AdapterDateFns}
                              style={{ marginTop: "15px" }}
                            >
                              <DateTimePicker
                                type="date"
                                name="deactivation_date"
                                label="OBT Complete Date"
                                inputFormat="dd/MM/yyyy hh:mm a"
                                value={
                                  memberVerificationData.obt_approve_date != ""
                                    ? moment(
                                      memberVerificationData.obt_approve_date,
                                      "DD-MM-YYYY hh:mm A"
                                    ).toDate()
                                    : null
                                }
                                onChange={(newDate) => {
                                  setMemberVerificationData({
                                    ...memberVerificationData,
                                    obt_approve_date: moment(newDate).format("DD-MM-YYYY hh:mm A")
                                  });
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    InputProps={{
                                      ...params.InputProps,
                                      endAdornment: (
                                        <>
                                          {memberVerificationData.obt_approve_date && (
                                            <IconButton
                                              onClick={() =>
                                                setMemberVerificationData({
                                                  ...memberVerificationData,
                                                  obt_approve_date: null
                                                })
                                              }
                                            >
                                              <ClearIcon fontSize="small" />
                                            </IconButton>
                                          )}
                                          {params.InputProps.endAdornment}
                                        </>
                                      )
                                    }}
                                  />
                                )}
                              />
                            </LocalizationProvider>
                          </Stack>
                        </Stack>
                      </Grid>
                      <Grid item xs={6}>
                        <Stack>
                          <FormControl component="fieldset">
                            <FormLabel component="legend">
                              Enable Green Tick / V2V card Complete
                            </FormLabel>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={memberVerificationData.isV2V}
                                    onChange={(e) => {
                                      setMemberVerificationData({
                                        ...memberVerificationData,
                                        isV2V: e.target.checked
                                      });
                                    }}
                                  />
                                }
                                label="Enable Green Tick / V2V card Complete"
                              />
                            </FormGroup>
                          </FormControl>
                          <Stack spacing={3} style={{ marginTop: "15px" }}>
                            <LocalizationProvider
                              dateAdapter={AdapterDateFns}
                              style={{ marginTop: "15px" }}
                            >
                              <DateTimePicker
                                type="date"
                                name="deactivation_date"
                                label="V2V Complete Date"
                                inputFormat="dd/MM/yyyy hh:mm a"
                                value={
                                  memberVerificationData.date != null
                                    ? moment(
                                      memberVerificationData.date,
                                      "DD-MM-YYYY hh:mm A"
                                    ).toDate()
                                    : null
                                }
                                onChange={(newDate) => {
                                  setMemberVerificationData({
                                    ...memberVerificationData,
                                    date: moment(newDate).format("DD-MM-YYYY hh:mm A")
                                  });
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    InputProps={{
                                      ...params.InputProps,
                                      endAdornment: (
                                        <>
                                          {memberVerificationData.date && (
                                            <IconButton
                                              onClick={() =>
                                                setMemberVerificationData({
                                                  ...memberVerificationData,
                                                  date: null
                                                })
                                              }
                                            >
                                              <ClearIcon fontSize="small" />
                                            </IconButton>
                                          )}
                                          {params.InputProps.endAdornment}
                                        </>
                                      )
                                    }}
                                  />
                                )}
                              />
                            </LocalizationProvider>
                          </Stack>
                        </Stack>
                      </Grid>
                      {/* For Now Blue Tick Removed from city AMB */}
                      {/* When wver the client will ask for add again then remove the below condition */}
                      {(loginUser?.u_type == 0 ||
                        (loginUser?.u_type == 2 &&
                          loginUser?.p_user_id == 1 &&
                          loginUser?.management_p != 0)) && (
                          <Grid item xs={6} style={{ paddingTop: "20px" }}>
                            <Stack>
                              <FormControl component="fieldset">
                                <FormLabel component="legend">
                                  Enable Blue Tick / MGT Complete
                                </FormLabel>
                                <FormGroup>
                                  <FormControlLabel
                                    control={
                                      <Switch
                                        checked={memberVerificationData.isMGT}
                                        onChange={(e) => {
                                          setMemberVerificationData({
                                            ...memberVerificationData,
                                            isMGT: e.target.checked
                                          });
                                        }}
                                      />
                                    }
                                    label="Enable Blue Tick / MGT Complete"
                                  />
                                </FormGroup>
                              </FormControl>
                              <Stack spacing={3} style={{ marginTop: "15px" }}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                  <DatePicker
                                    type="date"
                                    name="blue_tick_assign_date"
                                    label="MGT Complete Date"
                                    inputFormat="dd/MM/yyyy"
                                    value={
                                      memberVerificationData.blue_tick_assign_date != null
                                        ? moment(
                                          memberVerificationData.blue_tick_assign_date,
                                          "DD/MM/YYYY"
                                        )
                                        : null
                                    }
                                    onChange={(newDate) => {
                                      setMemberVerificationData({
                                        ...memberVerificationData,
                                        blue_tick_assign_date: moment(newDate).format("DD-MM-YYYY")
                                      });
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        InputProps={{
                                          ...params.InputProps,
                                          endAdornment: (
                                            <>
                                              {memberVerificationData.blue_tick_assign_date && (
                                                <IconButton
                                                  onClick={() =>
                                                    setMemberVerificationData({
                                                      ...memberVerificationData,
                                                      blue_tick_assign_date: null
                                                    })
                                                  }
                                                >
                                                  <ClearIcon fontSize="small" />
                                                </IconButton>
                                              )}
                                              {params.InputProps.endAdornment}
                                            </>
                                          )
                                        }}
                                      />
                                    )}
                                  />
                                </LocalizationProvider>
                              </Stack>
                            </Stack>
                            {/* <Stack spacing={3} style={{ marginBottom: "15px" }}>
                          <LocalizationProvider
                            dateAdapter={AdapterDateFns}
                            style={{ marginTop: "15px" }}
                          >
                            <DatePicker
                              type="date"
                              name="deactivation_date"
                              label="Date "
                              inputFormat="dd/MM/yyyy"
                              value={
                                memberVerificationData.date != null
                                  ? moment(
                                      memberVerificationData.date,
                                      "DD/MM/YYYY"
                                    )
                                  : null
                              }
                              onChange={(newDate) => {
                                setMemberVerificationData({
                                  ...memberVerificationData,
                                  date: moment(newDate).format("DD-MM-YYYY"),
                                });
                              }}
                              renderInput={(params) => <TextField {...params} />}
                            />
                          </LocalizationProvider>
                        </Stack> */}
                          </Grid>
                        )}
                    </Grid>
                  </Stack>
                </Stack>
              )}

              {activeSection === 2 && (
                <Stack
                  sx={{
                    mt: 1,
                    mb: 1,
                    height: "50vh",
                    overflowY: "auto"
                  }}
                >
                  {historyData?.length > 0 ? (
                    <TableContainer
                      component={Paper}
                      sx={{
                        backgroundColor: "#f0f2f5",
                        p: 1
                      }}
                    >
                      <Table size="small">
                        <TableBody>
                          {historyData.map((item, index) => {
                            const oldData = JSON.parse(item.old_data || "{}");
                            const newData = JSON.parse(item.new_data || "{}");

                            const changedKeys = Object.keys(settingHistoryFieldName).filter(
                              (key) => {
                                const oldVal = Number(oldData?.[key]);
                                const newVal = Number(newData?.[key]);

                                // SPECIAL CASE: m_verify_status
                                if (key === "m_verify_status") {
                                  return (
                                    (oldVal !== 2 && newVal === 2) || // became 2
                                    (oldVal === 2 && newVal !== 2) // left 2
                                  );
                                }

                                // NORMAL CASE
                                return String(oldData?.[key]) !== String(newData?.[key]);
                              }
                            );

                            if (!changedKeys.length) return null;

                            return (
                              <TableRow key={index}>
                                <TableCell colSpan={changedKeys.length + 1} sx={{ border: "none" }}>
                                  <Paper
                                    elevation={0}
                                    sx={{
                                      mb: 2,
                                      p: 1,
                                      borderRadius: 2,
                                      borderLeft: "4px solid #1976d2",
                                      backgroundColor: "#fff",
                                      minWidth: 750
                                    }}
                                  >
                                    <Table size="small">
                                      <TableBody>
                                        <TableRow>
                                          <TableCell sx={{ fontWeight: 600, width: 150 }}>
                                            No
                                          </TableCell>
                                          <TableCell>{historyData.length - index}</TableCell>
                                        </TableRow>

                                        <TableRow>
                                          <TableCell sx={{ fontWeight: 600 }}>Updated By</TableCell>
                                          <TableCell>{item.name}</TableCell>
                                        </TableRow>

                                        <TableRow>
                                          <TableCell sx={{ fontWeight: 600 }}>Date</TableCell>
                                          <TableCell>
                                            {moment(item.updated_at).format("DD-MM-YYYY hh:mm A")}
                                          </TableCell>
                                        </TableRow>

                                        <TableRow>
                                          <TableCell sx={{ fontWeight: 600 }}>Setting</TableCell>
                                          {changedKeys.map((key) => (
                                            <TableCell key={key}>
                                              {settingHistoryFieldName[key]}
                                            </TableCell>
                                          ))}
                                        </TableRow>

                                        <TableRow>
                                          <TableCell sx={{ fontWeight: 600 }}>Old Value</TableCell>
                                          {changedKeys.map((key) => (
                                            <TableCell key={key}>
                                              {renderValue(key, oldData?.[key])}
                                            </TableCell>
                                          ))}
                                        </TableRow>

                                        <TableRow>
                                          <TableCell sx={{ fontWeight: 600 }}>New Value</TableCell>
                                          {changedKeys.map((key) => (
                                            <TableCell key={key}>
                                              {renderValue(key, newData?.[key])}
                                            </TableCell>
                                          ))}
                                        </TableRow>
                                      </TableBody>
                                    </Table>
                                  </Paper>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  ) : (
                    <Stack alignItems="center" mt={2}>
                      No History Found
                    </Stack>
                  )}
                </Stack>
              )}
            </div>
            <hr />
            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  setMemberVerificationModal(false);
                }}
              >
                Close
              </Button>
              {activeSection !== 2 && (
                <Button
                  variant="contained"
                  onClick={() => {
                    changeGreenVerify();
                    // changestatus(
                    //   memberdeactiveReasons.m_id,
                    //   memberdeactiveReasons.status,
                    //   memberdeactiveReasons.reason,
                    //   memberdeactiveReasons.deactivation_date
                    // );
                  }}
                  disabled={isLoading}
                  startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                >
                  Confirm
                </Button>
              )}
            </div>
          </div>
        </Box>
        {/* changestatus(row.m_id, 0); */}
      </Modal>
      {/* Member Deactivate Add Reason Modal */}
      <Modal
        open={memberDeActiveModal}
        onClose={cancelmemberDeActiveModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Add Member De-activation Reason
          </Typography>

          <div style={{ padding: "10px" }}>
            <div style={{ maxHeight: "480px" }}>
              <Stack spacing={10} style={{ marginBottom: "10px", marginTop: "10px" }}>
                <Stack spacing={10} style={{ marginBottom: "15px" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <LocalizationProvider
                          dateAdapter={AdapterDateFns}
                          style={{ marginTop: "15px" }}
                        >
                          <DatePicker
                            type="date"
                            name="deactivation_date"
                            label="Date "
                            inputFormat="dd/MM/yyyy"
                            value={
                              memberdeactiveReasons.deactivation_date != null
                                ? memberdeactiveReasons.deactivation_date
                                : null
                            }
                            onChange={(newDate) => {
                              setMemberdeactiveReasons({
                                ...memberdeactiveReasons,
                                deactivation_date: newDate
                              });
                              setMemberVerificationData(moment(newDate).format("DD-MM-YYYY"));
                            }}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </LocalizationProvider>
                      </Stack>
                    </Grid>
                    <Grid item xs={12}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        <label style={{ marginBottom: "10px" }}>Member Deactivate Reason</label>
                        <Select
                          // value={}
                          style={{ marginTop: "0px" }}
                          name="city_id"
                          onChange={(e) => {
                            setMemberdeactiveReasons({
                              ...memberdeactiveReasons,
                              reason: e.value
                            });
                          }}
                          options={
                            memberDeactivateReason?.map((c) => ({
                              value: c.m_d_r_id,
                              label: c.member_deactive_reason
                            })) || []
                          }
                        ></Select>
                      </Stack>
                    </Grid>
                    {/* <Grid item xs={12}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          height={10}
                          fullWidth
                          multiline
                          autoComplete="off"
                          type="text"
                          label="Reason"
                          name="reason"
                          onChange={(e) => {
                            setMemberdeactiveReasons({
                              ...memberdeactiveReasons,
                              reason: e.target.value,
                            });
                          }}
                        />
                      </Stack>
                    </Grid> */}
                  </Grid>
                </Stack>
                {/* </Card> */}
              </Stack>
            </div>
            <hr />
            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  setmemberDeActiveModal(false);
                }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  changestatus(
                    memberdeactiveReasons.m_id,
                    memberdeactiveReasons.status,
                    memberdeactiveReasons.mobile_no,
                    memberdeactiveReasons.reason,
                    memberdeactiveReasons.deactivation_date
                  );
                }}
                disabled={isLoading}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                Confirm
              </Button>
            </div>
          </div>
        </Box>
        {/* changestatus(row.m_id, 0); */}
      </Modal>
      {/* Start Display Member Deactivation Reason Modal */}
      <Modal
        open={seeMemberDeActiveModal}
        onClose={closeMemberDeActiveModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            align="center"
            id="modal-modal-title"
            variant="h6"
            component="h2"
            style={{ borderBottom: "1px solid", paddingBottom: "5px" }}
          >
            Member Detactivation Reason
          </Typography>

          <div style={{ padding: "10px" }}>
            <div style={{ maxHeight: "480px" }}>
              <Stack spacing={10} style={{ marginBottom: "10px", marginTop: "10px" }}>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <b>Member Name</b>
                  </Grid>
                  <Grid item xs={9}>
                    <span>: {deActivateReasonData.memberName}</span>
                  </Grid>

                  <Grid item xs={3}>
                    <b>Deactivation Date</b>
                  </Grid>
                  <Grid item xs={9}>
                    <span>
                      :
                      {deActivateReasonData.deActivationDate != null ? (
                        deActivateReasonData.deActivationDate
                      ) : (
                        <span style={{ marginLeft: "80px" }}>-</span>
                      )}
                    </span>
                  </Grid>

                  <Grid item xs={3}>
                    <b>Reason</b>
                  </Grid>
                  <Grid item xs={9}>
                    <span>
                      :
                      {deActivateReasonData.deActivationReason != null ? (
                        deActivateReasonData.deActivationReason
                      ) : (
                        <span style={{ marginLeft: "80px" }}>-</span>
                      )}
                    </span>
                  </Grid>
                </Grid>
              </Stack>
            </div>
          </div>
          <div
            style={{
              margin: "10px auto",
              display: "flex",
              justifyContent: "center"
            }}
          >
            <Button variant="contained" onClick={closeMemberDeActiveModal}>
              Close
            </Button>
          </div>
        </Box>
      </Modal>
      {/* End Display Member Deactivation Reason Modal */}
      {/* Member Fees List Modal */}
      <Modal
        open={memberfeeModal}
        onClose={cancelModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...style, width: 750, maxWidth: "95%", borderRadius: 2, p: 3 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
            <Typography
              id="modal-modal-title"
              variant="h5"
              component="h2"
              sx={{ fontWeight: 700, color: "#1c4766" }}
            >
              Fee & Invoice Details
            </Typography>
            <IconButton onClick={cancelModal} size="small" sx={{ color: "text.secondary" }}>
              <Close sx={{ fontSize: 22 }} />
            </IconButton>
          </Box>
          <Tabs
            value={feeModalTab}
            onChange={(e, val) => setFeeModalTab(val)}
            sx={{ mb: 2, borderBottom: 1, borderColor: "divider" }}
          >
            <Tab label="Fee History" value={0} />
            <Tab label="Other Invoices" value={1} />
          </Tabs>
          <div>
            <TableContainer
              component={Paper}
              elevation={0}
              sx={{
                maxHeight: "400px",
                overflowY: "auto",
                border: "1px solid #e2e8f0",
                borderRadius: "8px",
                mb: 1,
                "&::-webkit-scrollbar": {
                  width: "6px"
                },
                "&::-webkit-scrollbar-track": {
                  background: "transparent"
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#cbd5e1",
                  borderRadius: "3px"
                }
              }}
            >
              {isFeeLoading ? (
                <Box
                  sx={{ py: 6, display: "flex", justifyContent: "center", alignItems: "center" }}
                >
                  <CircularProgress size={40} sx={{ color: "#1c4766" }} />
                </Box>
              ) : feeModalTab === 0 ? (
                memberfeedata.length !== 0 ? (
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{ fontWeight: 600, bgcolor: "#f8fafc", color: "#1c4766", py: 1.5 }}
                        >
                          Payment Date
                        </TableCell>
                        <TableCell
                          sx={{ fontWeight: 600, bgcolor: "#f8fafc", color: "#1c4766", py: 1.5 }}
                          align="right"
                        >
                          Amount
                        </TableCell>
                        <TableCell
                          sx={{ fontWeight: 600, bgcolor: "#f8fafc", color: "#1c4766", py: 1.5 }}
                          align="center"
                        >
                          Invoice
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {memberfeedata.map((m, index) => (
                        <TableRow
                          key={index}
                          hover
                          sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                        >
                          <TableCell sx={{ py: 1.5 }}>
                            <Stack direction="row" alignItems="center" spacing={1}>
                              <CalendarMonth sx={{ color: "#64748b", fontSize: 20 }} />
                              <Typography variant="body2" sx={{ fontWeight: 500, color: "#334155" }}>
                                {m.date}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell align="right" sx={{ py: 1.5 }}>
                            <Typography variant="body2" sx={{ fontWeight: 700, color: "#16a34a" }}>
                              ₹ {Number(m.member_fee).toLocaleString("en-IN")}
                            </Typography>
                          </TableCell>
                          <TableCell align="center" sx={{ py: 1.5 }}>
                            {m?.i_id > 0 && (
                              <Tooltip title="Download Invoice">
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    handleDownload(
                                      `${Routes.API_HOSTNAME}invoice-pdf/${m?.invoice_url}`,
                                      m?.invoice_url
                                    );
                                  }}
                                  sx={{
                                    color: "#1976d2",
                                    backgroundColor: "#eff6ff",
                                    "&:hover": {
                                      backgroundColor: "#dbeafe"
                                    }
                                  }}
                                >
                                  <DownloadIcon sx={{ fontSize: 20 }} />
                                </IconButton>
                              </Tooltip>
                            )}
                            {m?.i_id === 0 &&
                              (loginUser?.u_type == 0 ||
                                (loginUser?.u_type == 2 && loginUser?.management_p == 1)) && (
                                <Tooltip title="Generate Invoice">
                                  <IconButton
                                    size="small"
                                    onClick={() => {
                                      setmemberfeeModal(false);
                                      setGenerateInvoiceModal(true);
                                    }}
                                    sx={{
                                      color: "#1976d2",
                                      backgroundColor: "#eff6ff",
                                      "&:hover": {
                                        backgroundColor: "#dbeafe"
                                      }
                                    }}
                                  >
                                    <ReceiptLongIcon sx={{ fontSize: 20 }} />
                                  </IconButton>
                                </Tooltip>
                              )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                ) : (
                  <Box
                    sx={{
                      py: 6,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >
                    <ReceiptLongIcon sx={{ fontSize: 48, color: "#94a3b8", mb: 1 }} />
                    <Typography variant="subtitle1" color="text.secondary" sx={{ fontWeight: 500 }}>
                      No Fee History Found
                    </Typography>
                  </Box>
                )) : (
                otherInvoiceList.length !== 0 ? (
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600, bgcolor: "#f8fafc", color: "#1c4766", py: 1.5 }}>
                          Invoice No
                        </TableCell>
                        <TableCell sx={{ fontWeight: 600, bgcolor: "#f8fafc", color: "#1c4766", py: 1.5 }}>
                          Payment Date
                        </TableCell>
                        <TableCell sx={{ fontWeight: 600, bgcolor: "#f8fafc", color: "#1c4766", py: 1.5 }} align="right">
                          Total
                        </TableCell>
                        <TableCell sx={{ fontWeight: 600, bgcolor: "#f8fafc", color: "#1c4766", py: 1.5 }} align="center">
                          Download
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {otherInvoiceList.map((inv, index) => (
                        <TableRow key={index} hover sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                          <TableCell sx={{ py: 1.5 }}>
                            <Typography variant="body2" sx={{ fontWeight: 500, color: "#334155" }}>
                              {inv.i_prefix}{inv.i_no}
                            </Typography>
                          </TableCell>
                          <TableCell sx={{ py: 1.5 }}>
                            <Stack direction="row" alignItems="center" spacing={1}>
                              <CalendarMonth sx={{ color: "#64748b", fontSize: 20 }} />
                              <Typography variant="body2" sx={{ fontWeight: 500, color: "#334155" }}>
                                {inv.payment_date}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell align="right" sx={{ py: 1.5 }}>
                            <Typography variant="body2" sx={{ fontWeight: 700, color: "#16a34a" }}>
                              ₹ {Number(inv.i_total_amt).toLocaleString("en-IN")}
                            </Typography>
                          </TableCell>
                          <TableCell align="center" sx={{ py: 1.5 }}>
                            {inv.i_file_name && (
                              <Tooltip title="Download Invoice">
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    handleDownload(
                                      `${Routes.API_HOSTNAME}invoice-pdf/${inv.i_file_name}`,
                                      inv.i_file_name
                                    );
                                  }}
                                  sx={{
                                    color: "#1976d2",
                                    backgroundColor: "#eff6ff",
                                    "&:hover": { backgroundColor: "#dbeafe" }
                                  }}
                                >
                                  <DownloadIcon sx={{ fontSize: 20 }} />
                                </IconButton>
                              </Tooltip>
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                ) : (
                  <Box sx={{ py: 6, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <ReceiptLongIcon sx={{ fontSize: 48, color: "#94a3b8", mb: 1 }} />
                    <Typography variant="subtitle1" color="text.secondary" sx={{ fontWeight: 500 }}>
                      No Other Invoices Found
                    </Typography>
                  </Box>
                )
              )}
            </TableContainer>
            <Box display="flex" justifyContent="flex-end" mt={3}>
              <Button
                variant="contained"
                onClick={cancelModal}
                sx={{
                  bgcolor: "#1c4766",
                  color: "#fff",
                  px: 3,
                  py: 0.75,
                  borderRadius: "6px",
                  textTransform: "none",
                  fontWeight: 600,
                  "&:hover": {
                    bgcolor: "#123047"
                  }
                }}
              >
                Close
              </Button>
            </Box>
          </div>
        </Box>
      </Modal>

      {/* Display Member Deactivation Reason */}

      {/* Member Achivement Modal Open */}
      <Modal
        open={achievementModal}
        onClose={
          () => (
            toggleAchievementModal(),
            setMemberSelecedAchievement({
              m_id: "",
              m_name: "",
              achievement: []
            }),
            getAchivementOptions()
          )
          // setMemberSelecedAchievement({
          //   ...memberSelecedAchievement,
          //   u_id: "",
          //   achievement: achievementOptions?.map((achive) => {
          //     return (
          //       achive.status == 1 && {
          //         p_id: achive.p_id,
          //         date: null,
          //         check: false,
          //       }
          //     );
          //   }),
          //   // achievement: [],
          // })
        }
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            align="center"
            marginBottom={0.25}
            borderBottom={1}
          >
            {pinMemberActiveName} Member's Achievement
          </Typography>

          <Button className="btn btn-export">
            <CSVLink
              data={memberSelecedAchievement.achievement.filter(
                (achievement) => achievement.check === true
              )}
              headers={export_columns_pinAssign}
              filename={`${pinMemberActiveName} Pin Data.csv`}
              className="btn btn-primary test"
              target="_blank"
            >
              Export CSV
            </CSVLink>
          </Button>
          <div style={{ padding: "15px 0 0 0" }}>
            <div style={{ maxHeight: "420px", overflow: "scroll", width: "100%" }}>
              <Grid container>
                {achievementOptions?.map((achievement, index) => {
                  return (
                    <>
                      <Grid item xs={6} sm={6} p={1}>
                        <Stack>
                          <FormLabel component="legend">{achievement.name}</FormLabel>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Switch
                                  name={achievement.p_id}
                                  checked={memberSelecedAchievement?.achievement[index]?.check}
                                  disabled={
                                    (Number(achievement.p_id) === 3 &&
                                      memberSelecedAchievement?.achievement?.some(
                                        (a) => Number(a?.p_id) === 4 && a?.check
                                      )) ||
                                    (Number(achievement.p_id) === 4 &&
                                      memberSelecedAchievement?.achievement?.some(
                                        (a) => Number(a?.p_id) === 3 && a?.check
                                      ))
                                  }
                                  onChange={() => handleSwitchChange(index)}
                                />
                              }
                            />
                          </FormGroup>
                        </Stack>
                        {memberSelecedAchievement?.achievement[index]?.check && (
                          <Stack>
                            <LocalizationProvider
                              dateAdapter={AdapterDateFns}
                              style={{ marginTop: "15px" }}
                            >
                              <DatePicker
                                type="date"
                                name="s_date"
                                label="Pin Assign Date "
                                inputFormat="dd/MM/yyyy"
                                // value={null}
                                value={
                                  memberSelecedAchievement?.achievement[index]?.date != null
                                    ? moment(
                                      memberSelecedAchievement?.achievement[index]?.date,
                                      "DD/MM/YYYY"
                                    )
                                    : null
                                }
                                onChange={(newDate) => {
                                  const updatedAchievement = [
                                    ...memberSelecedAchievement.achievement
                                  ];
                                  updatedAchievement[index].date =
                                    moment(newDate).format("DD-MM-YYYY");

                                  setMemberSelecedAchievement({
                                    ...memberSelecedAchievement,
                                    achievement: updatedAchievement
                                  });
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                  // onKeyDown={(e) => e.preventDefault()}
                                  />
                                )}
                              />
                            </LocalizationProvider>
                          </Stack>
                        )}
                      </Grid>
                    </>
                  );
                })}
              </Grid>
            </div>
            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "center"
              }}
            >
              <Button variant="outlined" onClick={toggleAchievementModal}>
                Close
              </Button>

              <Button
                variant="contained"
                className="ms-25"
                style={{ marginLeft: "15px" }}
                onClick={handleAchievementSubmit}
                disabled={isLoading}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                Submit
              </Button>
            </div>
          </div>
        </Box>
      </Modal>

      {/* Member Connected and Block List Modal - Redesigned */}
      <Modal
        open={connectedBlockModalOpen}
        onClose={() => setConnectedBlockModalOpen(false)}
        aria-labelledby="modal-connected-block-title"
        aria-describedby="modal-connected-block-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 600,
            maxWidth: "95%",
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: "12px",
            overflow: "hidden"
          }}
        >
          {/* Header */}
          <Box
            sx={{
              p: 2,
              borderBottom: "1px solid",
              borderColor: "divider",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 700, color: "#00182a" }}>
              Connected & Blocked Members
            </Typography>
            <IconButton size="small" onClick={() => setConnectedBlockModalOpen(false)}>
              <Close />
            </IconButton>
          </Box>

          {/* Tab Navigation */}
          <Tabs
            value={connectedBlockTab}
            onChange={(e, v) => setConnectedBlockTab(v)}
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              bgcolor: "#f2f4f6",
              "& .MuiTab-root": { textTransform: "none", fontWeight: 600, minHeight: 48 },
              "& .Mui-selected": { color: "#00182a !important" },
              "& .MuiTabs-indicator": { backgroundColor: "#00182a" }
            }}
          >
            <Tab
              icon={<PeopleIcon sx={{ fontSize: 20 }} />}
              iconPosition="start"
              label={`Connected Members (${getMemberConnectedListData?.length || 0})`}
            />
            <Tab
              icon={<BlockIcon sx={{ fontSize: 20 }} />}
              iconPosition="start"
              label={`Blocked Members (${getMemberBlockListData?.length || 0})`}
            />
          </Tabs>

          {/* Scrollable Content */}
          <Box sx={{ height: 400, overflow: "auto", p: 2, "&::-webkit-scrollbar": { width: "4px" }, "&::-webkit-scrollbar-thumb": { backgroundColor: "#c3c7cd", borderRadius: "10px" } }}>
            {/* Connected Tab */}
            {connectedBlockTab === 0 && (
              <>
                <Box
                  sx={{
                    bgcolor: "#ebf9f1",
                    p: 1.5,
                    borderRadius: 2,
                    mb: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 1
                  }}
                >
                  <CheckCircleIcon sx={{ color: "#2e7d32", fontSize: 20 }} />
                  <Typography variant="body2" sx={{ color: "#1b5e20", fontWeight: 600 }}>
                    {getMemberConnectedListData?.length || 0} Active Member Connections Confirmed
                  </Typography>
                </Box>
                {getMemberConnectedListData && getMemberConnectedListData.length > 0 ? (
                  getMemberConnectedListData.map((item, idx) => (
                    <Box
                      key={`connected-${idx}`}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        p: 1.5,
                        border: "1px solid",
                        borderColor: "divider",
                        borderRadius: 2,
                        mb: 1,
                        "&:hover": { boxShadow: 1 }
                      }}
                    >
                      <Box sx={{ position: "relative", display: "inline-block" }}>
                        <Avatar
                          src={item?.photo ? `${Routes.API_HOSTNAME}images/member/${item.photo}` : undefined}
                          sx={{
                            bgcolor: "#cce5ff",
                            color: "#1d4a6a",
                            fontWeight: 700,
                            width: 40,
                            height: 40,
                            fontSize: 16
                          }}
                        >
                          {item?.m_name
                            ?.split(" ")
                            .map((n) => n[0])
                            .join("")
                            .slice(0, 2)
                            .toUpperCase() || "?"}
                        </Avatar>
                        {(item?.m_verify_status === 1 || item?.m_verify_status === 2 || item?.m_verify_status === 3) && (
                          <Box
                            component="img"
                            src={item?.m_verify_status === 1 ? "/static/icons/verified.png" : item?.m_verify_status === 2 ? "/static/icons/verified_blue.png" : "/static/icons/verified_orange.png"}
                            alt="Verified"
                            sx={{ width: 16, height: 16, position: "absolute", top: -1, right: -1 }}
                          />
                        )}
                      </Box>
                      <Typography variant="body1" sx={{ fontWeight: 600, color: "#00182a" }}>
                        {item?.m_name}
                        {item?.chpt_name ? ` (${item.chpt_name})` : ""}
                      </Typography>
                    </Box>
                  ))
                ) : (
                  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 300, color: "text.secondary" }}>
                    <Typography>No Connected Members</Typography>
                  </Box>
                )}
              </>
            )}

            {/* Blocked Tab */}
            {connectedBlockTab === 1 && (
              <>
                <Box
                  sx={{
                    bgcolor: "#fce4e4",
                    p: 1.5,
                    borderRadius: 2,
                    mb: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 1
                  }}
                >
                  <WarningAmberIcon sx={{ color: "#c62828", fontSize: 20 }} />
                  <Typography variant="body2" sx={{ color: "#c62828", fontWeight: 600 }}>
                    {getMemberBlockListData?.length || 0} Member{getMemberBlockListData?.length !== 1 ? "s" : ""} currently restricted from activities
                  </Typography>
                </Box>
                {getMemberBlockListData && getMemberBlockListData.length > 0 ? (
                  getMemberBlockListData.map((item, idx) => (
                    <Box
                      key={`blocked-${idx}`}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        p: 1.5,
                        border: "1px solid",
                        borderColor: "error.main",
                        borderRadius: 2,
                        mb: 1,
                        "&:hover": { boxShadow: 1 }
                      }}
                    >
                      <Box sx={{ position: "relative", display: "inline-block" }}>
                        <Avatar
                          src={item?.photo ? `${Routes.API_HOSTNAME}images/member/${item.photo}` : undefined}
                          sx={{
                            bgcolor: "#ffdad6",
                            color: "#93000a",
                            fontWeight: 700,
                            width: 40,
                            height: 40,
                            fontSize: 16
                          }}
                        >
                          {item?.m_name
                            ?.split(" ")
                            .map((n) => n[0])
                            .join("")
                            .slice(0, 2)
                            .toUpperCase() || "?"}
                        </Avatar>
                        {(item?.m_verify_status === 1 || item?.m_verify_status === 2) && (
                          <Box
                            component="img"
                            src={item?.m_verify_status === 1 ? "/static/icons/verified.png" : "/static/icons/verified_blue.png"}
                            alt="Verified"
                            sx={{ width: 16, height: 16, position: "absolute", top: -1, right: -1 }}
                          />
                        )}
                      </Box>
                      <Typography variant="body1" sx={{ fontWeight: 600, color: "#00182a", flex: 1 }}>
                        {item?.m_name}
                        {item?.chpt_name ? ` (${item.chpt_name})` : ""}
                      </Typography>
                    </Box>
                  ))
                ) : (
                  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 300, color: "text.secondary" }}>
                    <Typography>No Blocked Members</Typography>
                  </Box>
                )}
              </>
            )}
          </Box>

          {/* Footer */}
          <Box
            sx={{
              p: 2,
              borderTop: "1px solid",
              borderColor: "divider",
              bgcolor: "#f2f4f6",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Switch
                checked={conMailStatus}
                onChange={handleToggleConnectionMail}
                size="small"
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#0b2d45",
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#0b2d45",
                  }
                }}
              />
              <Typography variant="body2" sx={{ color: "#43474d", fontWeight: 500 }}>
                Receive Connection mail
              </Typography>
            </Box>
            <Button
              variant="contained"
              onClick={() => setConnectedBlockModalOpen(false)}
              sx={{
                bgcolor: "#0b2d45",
                color: "#fff",
                textTransform: "none",
                px: 3,
                fontWeight: 600,
                "&:hover": { bgcolor: "#00182a" }
              }}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Page Contend */}
      <Page title="Member | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              Member
            </Typography>
            {step == 1 ? (
              <Stack direction="row" spacing={2}>
                <Button
                  variant="contained"
                  color="secondary"
                  sx={{
                    textTransform: "none"
                  }}
                  size="small"
                >
                  <CSVLink
                    data={exportMemberList}
                    headers={expo_columns_Additional}
                    filename={"MemberList With Additional Details.csv"}
                    target="_blank"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Export Additional Info
                  </CSVLink>
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{
                    textTransform: "none"
                  }}
                  size="small"
                >
                  <CSVLink
                    data={exportMemberList}
                    headers={expo_columns}
                    filename={"MemberList.csv"}
                    style={{ color: "#fff", textDecoration: "none" }}
                    target="_blank"
                  >
                    Export CSV
                  </CSVLink>
                </Button>
                {(loginUser?.u_type == 0 ||
                  (loginUser?.u_type == 2 && loginUser?.p_user_id == 1) ||
                  (loginUser?.u_type == 1 && step == 3)) && (
                    <Button
                      onClick={() => {
                        step == 1 ? setStep(2) : setStep(1);
                      }}
                      style={{ marginBottom: "0px" }}
                      variant="contained"
                    >
                      {step == 1 ? "Add Member" : "Back"}
                    </Button>
                  )}
              </Stack>
            ) : (
              (loginUser?.u_type == 0 ||
                (loginUser?.u_type == 2 && loginUser?.p_user_id == 1) ||
                (loginUser?.u_type == 1 && step == 3)) && (
                <Button
                  onClick={() => {
                    step == 1 ? setStep(2) : setStep(1);
                  }}
                  style={{ marginBottom: "0px" }}
                  variant="contained"
                >
                  {step == 1 ? "Add Member" : "Back"}
                </Button>
              )
            )}
          </Stack>

          {step != 1 && (
            <Card
              style={{
                paddingTop: "25px",
                paddingBottom: "25px"
              }}
            >
              <MemberForm data={editMember} setStep={setStep} step={step} memberlist={memberlist} />
            </Card>
          )}
          {step == 1 && (
            <>
              <Card style={{ paddingRight: "18px", paddingTop: "1px" }}>
                <Stack spacing={2}>
                  <Grid container spacing={1} alignItems="center">
                    {/* Member Filter Features */}
                    {/* <Grid
                      item
                      xs={12}
                      style={{
                        marginTop: "0",
                        paddingTop: "0",
                        textAlign: "center"
                      }}
                    >
                      <h3>Member Filter</h3>
                    </Grid> */}

                    <Grid item xs={12} lg={3} md={4} sm={6}>
                      <Stack spacing={0.5}>
                        <Typography variant="caption" sx={{ fontWeight: "bold", ml: 0.5 }}>
                          Select City
                        </Typography>
                        <Select
                          isDisabled={
                            loginUser?.u_type == 1 ||
                              (loginUser?.u_type == 2 &&
                                loginUser?.p_user_id != 1 &&
                                loginUser?.management_p == 1)
                              ? true
                              : false
                          }
                          value={
                            filtereddata.filterCity == 0
                              ? {
                                value: 0,
                                label: "All City"
                              }
                              : citylist.map((city) => {
                                return (
                                  filtereddata.filterCity == city.city_id && {
                                    value: city.city_id,
                                    label: city.city_name
                                  }
                                );
                              })
                          }
                          onChange={(e) => {
                            setFilteredData({
                              ...filtereddata,
                              filterCity: e.value,
                              filterchap: 0
                            });
                          }}
                          options={[
                            {
                              value: 0,
                              label: "All City"
                            },
                            ...citylist.map((city) => {
                              return {
                                label: city?.city_name,
                                value: city?.city_id
                              };
                            })
                          ]}
                        />
                      </Stack>
                    </Grid>

                    <Grid item xs={12} lg={3} md={4} sm={6}>
                      <Stack spacing={0.5}>
                        <Typography variant="caption" sx={{ fontWeight: "bold", ml: 0.5 }}>
                          Select Chapter
                        </Typography>
                        <Select
                          value={
                            filtereddata.filterchap == 0
                              ? { value: 0, label: "All Chapter" }
                              : chaptlist &&
                              chaptlist.map((c) => {
                                if (c.chpt_id == filtereddata.filterchap) {
                                  return {
                                    value: c.chpt_id,
                                    label: c.chpt_name
                                  };
                                }
                              })
                          }
                          style={{ marginTop: "0px" }}
                          name="chpt_id"
                          onChange={(e) => {
                            setFilteredData({
                              ...filtereddata,
                              filterchap: e.value
                            });
                          }}
                          options={[
                            {
                              value: 0,
                              label: "All Chapter"
                            },
                            ...(chaptlist &&
                              chaptlist
                                ?.map((chpt) => {
                                  if (filtereddata?.filterCity != 0) {
                                    if (chpt?.city_id == filtereddata?.filterCity) {
                                      return {
                                        value: chpt.chpt_id,
                                        label: chpt.chpt_name
                                      };
                                    }
                                  } else {
                                    return {
                                      value: chpt.chpt_id,
                                      label: chpt.chpt_name
                                    };
                                  }
                                })
                                .filter((f) => f != undefined))
                          ]}
                        ></Select>
                      </Stack>
                    </Grid>

                    <Grid item xs={12} lg={3} md={4} sm={6}>
                      <Stack spacing={0.5}>
                        <Typography variant="caption" sx={{ fontWeight: "bold", ml: 0.5 }}>
                          Select Member Position
                        </Typography>
                        <Select
                          value={memberPosition.map((c) => {
                            if (c.value == filtereddata.activePositionType) {
                              return { value: c.value, label: c.label };
                            }
                          })}
                          onChange={(e) => {
                            setFilteredData({
                              ...filtereddata,
                              activePositionType: e.value
                            });
                          }}
                          options={memberPosition}
                        />
                      </Stack>
                    </Grid>

                    <Grid item xs={12} lg={3} md={4} sm={6}>
                      <Stack spacing={0.5}>
                        <Typography variant="caption" sx={{ fontWeight: "bold", ml: 0.5 }}>
                          Select Member Type
                        </Typography>
                        <Select
                          value={memberType.map((c) => {
                            if (c.value == filtereddata.activeMemberSearchType) {
                              return { value: c.value, label: c.label };
                            }
                          })}
                          onChange={(e) => {
                            setFilteredData({
                              ...filtereddata,
                              activeMemberSearchType: e.value
                            });
                          }}
                          options={memberType}
                        />
                      </Stack>
                    </Grid>

                    <Grid item xs={12} lg={3} md={4} sm={6}>
                      <Stack spacing={0.5}>
                        <Typography variant="caption" sx={{ fontWeight: "bold", ml: 0.5 }}>
                          Select Member Tick
                        </Typography>
                        <Select
                          isMulti
                          options={memberTick}
                          value={memberTick.filter((c) =>
                            filtereddata.activeMemberTickType.includes(c.value)
                          )}
                          onChange={(selectedOptions) => {
                            const values = selectedOptions.map((opt) => opt.value);
                            let finalValues =
                              values.includes(-1) && values.length > 1
                                ? values.filter((val) => val !== -1)
                                : values;

                            setFilteredData({
                              ...filtereddata,
                              activeMemberTickType: finalValues
                            });
                          }}
                          hideSelectedOptions={false}
                          isClearable={false}
                        />
                      </Stack>
                    </Grid>

                    <Grid item xs={12} lg={3} md={4} sm={6}>
                      <Stack spacing={0.5}>
                        <Typography variant="caption" sx={{ fontWeight: "bold", ml: 0.5 }}>
                          Select Gender
                        </Typography>
                        <Select
                          value={gender?.map((c) => {
                            if (c.value == filtereddata.gender) {
                              return { value: c.value, label: c.label };
                            }
                          })}
                          onChange={(e) => {
                            setFilteredData({
                              ...filtereddata,
                              gender: e.value
                            });
                          }}
                          options={gender}
                        />
                      </Stack>
                    </Grid>

                    <Grid item xs={12} lg={3} md={4} sm={6}>
                      <Stack spacing={0.5}>
                        <Typography variant="caption" sx={{ fontWeight: "bold", ml: 0.5 }}>
                          Select Location Type
                        </Typography>
                        <Select
                          value={locationType?.map((c) => {
                            if (c.value == filtereddata.locationType) {
                              return { value: c.value, label: c.label };
                            }
                          })}
                          onChange={(e) => {
                            setFilteredData({
                              ...filtereddata,
                              locationType: e.value
                            });
                          }}
                          options={locationType}
                        />
                      </Stack>
                    </Grid>

                    <Grid item xs={12} lg={3} md={4} sm={6}>
                      <Stack spacing={0.5}>
                        <Typography variant="caption" sx={{ fontWeight: "bold", ml: 0.5 }}>
                          Select Invoice Type
                        </Typography>
                        <Select
                          value={invoiceTypeFilter?.map((option) => {
                            if (option.value == filtereddata.invoice) {
                              return { value: option.value, label: option.label };
                            }
                          })}
                          onChange={(e) => {
                            setFilteredData({
                              ...filtereddata,
                              invoice: e.value
                            });
                          }}
                          options={invoiceTypeFilter}
                        />
                      </Stack>
                    </Grid>

                    <Grid item xs={12}>
                      <Box
                        sx={{
                          p: 1,
                          border: "1px solid #e0e0e0",
                          borderRadius: 1,
                          bgcolor: "#fafafa",
                          mt: 0.5
                        }}
                      >
                        <Grid container spacing={1} alignItems="center">
                          <Grid item xs={12} md={5}>
                            <FormControl component="fieldset">
                              <FormLabel component="legend" sx={{ fontWeight: "bold", mb: 0.5 }}>
                                Search Member by Date
                              </FormLabel>
                              <RadioGroup
                                row
                                value={filtereddata.search_date_type}
                                onChange={(e) => {
                                  setFilteredData({
                                    ...filtereddata,
                                    search_date_type: e.target.value
                                  });
                                }}
                                name="p_type"
                              >
                                <FormControlLabel
                                  value="0"
                                  control={<Radio size="small" sx={{ p: 0.5, pl: 1 }} />}
                                  label={<Typography variant="body2">Join</Typography>}
                                />
                                <FormControlLabel
                                  value="1"
                                  control={<Radio size="small" sx={{ p: 0.5 }} />}
                                  label={<Typography variant="body2">Expire</Typography>}
                                />
                                <FormControlLabel
                                  value="2"
                                  control={<Radio size="small" sx={{ p: 0.5 }} />}
                                  label={<Typography variant="body2">Deactivate</Typography>}
                                />
                              </RadioGroup>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} md={7}>
                            <Stack direction="row" spacing={2} alignItems="center">
                              <Box sx={{ flex: 1 }}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                  <DatePicker
                                    label="Start Date"
                                    inputFormat="dd/MM/yyyy"
                                    value={filtereddata.startDate}
                                    onChange={(newDate) => {
                                      setFilteredData({
                                        ...filtereddata,
                                        startDate: newDate
                                      });
                                    }}
                                    renderInput={(params) => (
                                      <TextField {...params} size="small" fullWidth />
                                    )}
                                  />
                                </LocalizationProvider>
                              </Box>

                              <Box sx={{ flex: 1 }}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                  <DatePicker
                                    label="End Date"
                                    inputFormat="dd/MM/yyyy"
                                    value={filtereddata.endDate}
                                    onChange={(newDate) => {
                                      setFilteredData({
                                        ...filtereddata,
                                        endDate: newDate
                                      });
                                    }}
                                    renderInput={(params) => (
                                      <TextField {...params} size="small" fullWidth />
                                    )}
                                  />
                                </LocalizationProvider>
                              </Box>
                            </Stack>
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Grid container spacing={1} alignItems="flex-end">
                        <Grid item xs={8}>
                          <Stack spacing={0.5}>
                            <Typography variant="caption" sx={{ fontWeight: "bold", ml: 0.5 }}>
                              Search Member
                            </Typography>
                            <TextField
                              fullWidth
                              autoComplete="off"
                              type="text"
                              placeholder="Search Member"
                              name="search"
                              value={filtereddata?.filtermember ? filtereddata?.filtermember : ""}
                              onChange={(e) => {
                                setFilteredData({
                                  ...filtereddata,
                                  filtermember: e.target.value
                                });
                              }}
                              size="small"
                              sx={{
                                "& .MuiInputBase-root": { height: 40 }
                              }}
                            />
                          </Stack>
                        </Grid>
                        <Grid item xs={4}>
                          <Stack direction="row" spacing={1}>
                            <Button
                              variant="contained"
                              onClick={FilterDateWise}
                              fullWidth
                              sx={{
                                bgcolor: "#1c4766",
                                "&:hover": { bgcolor: "#14344d" },
                                height: 40
                              }}
                            >
                              Search
                            </Button>
                            <Button
                              variant="outlined"
                              onClick={() => {
                                setFilteredData({
                                  filterchap: 0,
                                  filtermember: "",
                                  gender: -1,
                                  invoice: -1,
                                  locationType: -1,
                                  startDate: null,
                                  endDate: null,
                                  search_date_type: 0,
                                  activeMemberSearchType: 0,
                                  activePositionType: 0,
                                  activeMemberTickType: [-1],
                                  filterCity:
                                    loginUser?.u_type == 1 ||
                                      (loginUser?.u_type == 2 &&
                                        loginUser?.p_user_id != 1 &&
                                        loginUser?.management_p == 1)
                                      ? loginUser?.city_id
                                      : 0
                                });
                              }}
                              fullWidth
                              sx={{
                                color: "#1c4766",
                                borderColor: "#1c4766",
                                "&:hover": {
                                  borderColor: "#14344d",
                                  bgcolor: "rgba(28, 71, 102, 0.04)"
                                },
                                height: 40
                              }}
                            >
                              Clear
                            </Button>
                          </Stack>
                        </Grid>
                      </Grid>
                    </Grid>

                    {/* <Grid item xs={3}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <LocalizationProvider
                          dateAdapter={AdapterDateFns}
                          style={{ marginTop: "15px" }}
                        >
                          <DatePicker
                            type="date"
                            name="s_date"
                            label="Start Date "
                            inputFormat="dd/MM/yyyy"
                            value={filtereddata.startDate != null ? filtereddata.startDate : null}
                            onChange={(newDate) => {
                              setFilteredData({
                                ...filtereddata,
                                startDate: newDate
                              });
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                // onKeyDown={(e) => e.preventDefault()}
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </Stack>
                    </Grid> */}
                    {/* <Grid item xs={3}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <LocalizationProvider
                          dateAdapter={AdapterDateFns}
                          style={{ marginTop: "15px" }}
                        >
                          <DatePicker
                            type="date"
                            name="e_date"
                            label="End Date "
                            inputFormat="dd/MM/yyyy"
                            value={filtereddata.endDate != null ? filtereddata.endDate : null}
                            onChange={(newDate) => {
                              setFilteredData({
                                ...filtereddata,
                                endDate: newDate
                              });
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                // onKeyDown={(e) => e.preventDefault()}
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </Stack>
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-around",
                        padding: "0"
                      }}
                    >
                      <Button variant="contained" onClick={FilterDateWise}>
                        Search
                      </Button>
                      <Button
                        variant="contained"
                        onClick={async () => {
                          setFilteredData({
                            filterchap: 0,
                            filtermember: "",
                            startDate: null,
                            endDate: null,
                            search_date_type: 0,
                            activeMemberSearchType: 0,
                            activePositionType: 0,
                            activeMemberTickType: [-1],
                            filterCity:
                              loginUser?.u_type == 1 ||
                              (loginUser?.u_type == 2 &&
                                loginUser?.p_user_id != 1 &&
                                loginUser?.management_p == 1)
                                ? loginUser?.city_id
                                : 0
                          });
                        }}
                      >
                        Clear
                      </Button>
                    </Grid> */}
                    <Grid item xs={12}>
                      <Stack direction="row" spacing={2} sx={{ mt: 1 }}>
                        <Card
                          sx={{
                            flex: 1,
                            bgcolor: "#1c4766",
                            color: "#fff",
                            padding: "15px",
                            borderRadius: 1
                          }}
                        >
                          <Stack direction="row" justifyContent="space-between" alignItems="center">
                            <Typography
                              variant="subtitle2"
                              sx={{ fontWeight: "bold", fontSize: "18px" }}
                            >
                              Active Member
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              sx={{ fontWeight: "bold", fontSize: "18px" }}
                            >
                              {activeMembercnt}
                            </Typography>
                          </Stack>
                        </Card>
                        <Card
                          sx={{
                            flex: 0.6,
                            bgcolor: "#1c4766",
                            color: "#fff",
                            padding: "15px",
                            borderRadius: 1
                          }}
                        >
                          <Stack direction="row" justifyContent="space-between" alignItems="center">
                            <Typography
                              variant="subtitle2"
                              sx={{ fontWeight: "bold", fontSize: "18px" }}
                            >
                              Director
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              sx={{ fontWeight: "bold", fontSize: "18px" }}
                            >
                              {directorcnt}
                            </Typography>
                          </Stack>
                        </Card>
                        <Card
                          sx={{
                            flex: 1,
                            bgcolor: "#1c4766",
                            color: "#fff",
                            padding: "15px",
                            borderRadius: 1
                          }}
                        >
                          <Stack direction="row" justifyContent="space-between" alignItems="center">
                            <Typography
                              variant="subtitle2"
                              sx={{ fontWeight: "bold", fontSize: "18px" }}
                            >
                              De-Active Member
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              sx={{ fontWeight: "bold", fontSize: "18px" }}
                            >
                              {deactiveMembercnt}
                            </Typography>
                          </Stack>
                        </Card>
                      </Stack>
                    </Grid>
                  </Grid>
                </Stack>

                <DataTable
                  // title="Member List"
                  filter
                  pagination
                  highlightOnHover
                  pointerOnHover
                  columns={columns}
                  data={newMemeberList}
                  conditionalRowStyles={conditionalRowStyles}
                  progressPending={isLoading}
                  progressComponent={<CustomLoader />}
                // onRowClicked={(row) => {
                //   setMemberProfileId(row?.m_id);
                //   toggleMemberProfileModal();
                // }}
                />
              </Card>
            </>
          )}
          {/* End Category Form */}
        </Container>
      </Page>
      {memberProfileModal && (
        <MemberProfileModal
          memberProfileModal={memberProfileModal}
          memberProfileId={memberProfileId}
          setMemberProfileId={setMemberProfileId}
          toggleMemberProfileModal={toggleMemberProfileModal}
        />
      )}

      {inductedMemberProfileModal && (
        <InductedMemberProfileModal
          inductedMemberProfileModal={inductedMemberProfileModal}
          memberProfileId={memberProfileId}
          setMemberProfileId={setMemberProfileId}
          toggleInductedMemberProfileModal={toggleInductedMemberProfileModal}
        />
      )}

      {generateInvoiceModal && (
        <Modal
          open={generateInvoiceModal}
          onClose={() => {
            setGenerateInvoiceModal(false);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <InvoiceDownloadForm
            setGenerateInvoiceModal={setGenerateInvoiceModal}
            generateInvoiceModal={generateInvoiceModal}
            leadDetails={leadDetails}
            setLeadHistory={setLeadDetails}
            type={"member"}
            setIsInvoiceGenerated={setIsInvoiceGenerated}
          />
        </Modal>
      )}
    </>
  );
}
